// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Oswald:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
        /* DMK Theme - Light Mode (Black & Red) */
        --background: 0 0% 97%;
        --foreground: 0 0% 8%;
        --card: 0 0% 100%;
        --card-foreground: 0 0% 8%;
        --popover: 0 0% 100%;
        --popover-foreground: 0 0% 8%;

        /* DMK Black Primary */
        --primary: 0 0% 8%;
        --primary-foreground: 0 0% 100%;

        /* DMK Red Accent */
        --secondary: 0 84% 40%;
        --secondary-foreground: 0 0% 100%;

        --muted: 0 0% 94%;
        --muted-foreground: 0 0% 40%;
        --accent: 0 84% 40%;
        --accent-foreground: 0 0% 100%;
        --destructive: 0 84% 60%;
        --destructive-foreground: 0 0% 100%;
        --border: 0 0% 82%;
        --input: 0 0% 82%;
        --ring: 0 84% 40%;
        --radius: 0.5rem;

        /* Custom DMK colors */
        --police-navy: 0 0% 8%;
        --police-navy-dark: 0 0% 5%;
        --police-gold: 0 84% 40%;
        --police-badge: 0 84% 35%;
        --police-silver: 0 0% 71%;
        
        /* Safe area for notched devices */
        --safe-area-inset-top: env(safe-area-inset-top);
        --safe-area-inset-bottom: env(safe-area-inset-bottom);
        --safe-area-inset-left: env(safe-area-inset-left);
        --safe-area-inset-right: env(safe-area-inset-right);
    }

.dark {
        /* DMK Theme - Dark Mode (Black & Red) */
        --background: 0 0% 5%;
        --foreground: 0 0% 95%;
        --card: 0 0% 8%;
        --card-foreground: 0 0% 95%;
        --popover: 0 0% 8%;
        --popover-foreground: 0 0% 95%;

        /* DMK Black Primary */
        --primary: 0 0% 12%;
        --primary-foreground: 0 0% 100%;

        /* DMK Red Accent */
        --secondary: 0 84% 45%;
        --secondary-foreground: 0 0% 100%;

        --muted: 0 0% 14%;
        --muted-foreground: 0 0% 65%;
        --accent: 0 84% 45%;
        --accent-foreground: 0 0% 100%;
        --destructive: 0 84% 60%;
        --destructive-foreground: 0 0% 100%;
        --border: 0 0% 18%;
        --input: 0 0% 14%;
        --ring: 0 84% 45%;

        /* Custom DMK colors */
        --police-navy: 0 0% 12%;
        --police-navy-dark: 0 0% 8%;
        --police-gold: 0 84% 45%;
        --police-badge: 0 84% 38%;
        --police-silver: 0 0% 65%;
    }

* {
        border-color: hsl(var(--border));
    }

body {
        background-color: hsl(var(--background));
        color: hsl(var(--foreground));
    }

/* Focus visible styles for accessibility - GOV-style */

*:focus-visible {
        outline: 2px solid hsl(var(--ring));
        outline-offset: 2px;
        border-radius: calc(var(--radius) - 2px);
    }

/* Better touch targets on mobile */

button, 
    [role="button"], 
    a {
        touch-action: manipulation;
    }

/* Smooth scrolling */

html {
        scroll-behavior: smooth;
    }

/* Better text rendering */

h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        text-wrap: balance;
    }

p {
        text-wrap: pretty;
    }

[data-debug-wrapper="true"] {
        display: contents !important;
    }

[data-debug-wrapper="true"]>* {
        margin-left: inherit;
        margin-right: inherit;
        margin-top: inherit;
        margin-bottom: inherit;
        padding-left: inherit;
        padding-right: inherit;
        padding-top: inherit;
        padding-bottom: inherit;
        column-gap: inherit;
        row-gap: inherit;
        gap: inherit;
        border-left-width: inherit;
        border-right-width: inherit;
        border-top-width: inherit;
        border-bottom-width: inherit;
        border-left-style: inherit;
        border-right-style: inherit;
        border-top-style: inherit;
        border-bottom-style: inherit;
        border-left-color: inherit;
        border-right-color: inherit;
        border-top-color: inherit;
        border-bottom-color: inherit;
    }

/* Mobile-first heading sizes */
.\\!container{
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1600px){

  .\\!container{
    max-width: 1600px !important;
  }

  .container{
    max-width: 1600px;
  }
}
/* GOV-style cards with professional borders */
/* Professional header styling */
/* GOV badge/chip styling */
/* Mobile-first container */
/* Touch-friendly button base */
/* Responsive grid that stacks on mobile */
/* Mobile-first stat cards */
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-1\\.5{
  inset: -0.375rem;
}
.inset-0{
  inset: 0px;
}
.inset-2{
  inset: 0.5rem;
}
.inset-2\\.5{
  inset: 0.625rem;
}
.inset-4{
  inset: 1rem;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-2{
  bottom: -0.5rem;
}
.-bottom-24{
  bottom: -6rem;
}
.-left-12{
  left: -3rem;
}
.-left-2{
  left: -0.5rem;
}
.-left-24{
  left: -6rem;
}
.-left-3{
  left: -0.75rem;
}
.-left-6{
  left: -1.5rem;
}
.-left-\\[24px\\]{
  left: -24px;
}
.-left-\\[27px\\]{
  left: -27px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-right-2\\.5{
  right: -0.625rem;
}
.-right-24{
  right: -6rem;
}
.-right-28{
  right: -7rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-4{
  right: -1rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-12{
  top: -3rem;
}
.-top-24{
  top: -6rem;
}
.-top-3{
  top: -0.75rem;
}
.-top-4{
  top: -1rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-12{
  bottom: 3rem;
}
.bottom-14{
  bottom: 3.5rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[-16px\\]{
  bottom: -16px;
}
.bottom-\\[20\\%\\]{
  bottom: 20%;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-\\[10\\%\\]{
  left: 10%;
}
.left-\\[11px\\]{
  left: 11px;
}
.left-\\[18px\\]{
  left: 18px;
}
.left-\\[20px\\]{
  left: 20px;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[15\\%\\]{
  right: 15%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-12{
  top: 3rem;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-\\[15\\%\\]{
  top: 15%;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[40px\\]{
  top: 40px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-\\[60px\\]{
  top: 60px;
}
.top-\\[75px\\]{
  top: 75px;
}
.top-\\[76px\\]{
  top: 76px;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[110\\]{
  z-index: 110;
}
.z-\\[120\\]{
  z-index: 120;
}
.z-\\[121\\]{
  z-index: 121;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[9998\\]{
  z-index: 9998;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.col-span-full{
  grid-column: 1 / -1;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.m-auto{
  margin: auto;
}
.\\!my-6{
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5{
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5{
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-my-0\\.5{
  margin-top: -0.125rem;
  margin-bottom: -0.125rem;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5{
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.-mb-2{
  margin-bottom: -0.5rem;
}
.-mb-5{
  margin-bottom: -1.25rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mr-4{
  margin-right: -1rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-12{
  margin-top: -3rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-\\[1px\\]{
  margin-top: -1px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.line-clamp-6{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-\\[16\\/9\\]{
  aspect-ratio: 16/9;
}
.aspect-\\[2\\/1\\]{
  aspect-ratio: 2/1;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-\\[4\\/5\\]{
  aspect-ratio: 4/5;
}
.aspect-\\[9\\/16\\]{
  aspect-ratio: 9/16;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-52{
  height: 13rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[12px\\]{
  height: 12px;
}
.h-\\[130px\\]{
  height: 130px;
}
.h-\\[136px\\]{
  height: 136px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[14px\\]{
  height: 14px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20mm\\]{
  height: 20mm;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[25mm\\]{
  height: 25mm;
}
.h-\\[260px\\]{
  height: 260px;
}
.h-\\[280px\\]{
  height: 280px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[340px\\]{
  height: 340px;
}
.h-\\[380px\\]{
  height: 380px;
}
.h-\\[390px\\]{
  height: 390px;
}
.h-\\[430px\\]{
  height: 430px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[580px\\]{
  height: 580px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[75px\\]{
  height: 75px;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[92px\\]{
  height: 92px;
}
.h-\\[92vh\\]{
  height: 92vh;
}
.h-\\[95vh\\]{
  height: 95vh;
}
.h-\\[calc\\(100vh-120px\\)\\]{
  height: calc(100vh - 120px);
}
.h-\\[calc\\(100vh-12rem\\)\\]{
  height: calc(100vh - 12rem);
}
.h-\\[calc\\(100vh-140px\\)\\]{
  height: calc(100vh - 140px);
}
.h-\\[calc\\(100vh-64px\\)\\]{
  height: calc(100vh - 64px);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-20{
  max-height: 5rem;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[1000px\\]{
  max-height: 1000px;
}
.max-h-\\[190px\\]{
  max-height: 190px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[215px\\]{
  max-height: 215px;
}
.max-h-\\[250px\\]{
  max-height: 250px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[320px\\]{
  max-height: 320px;
}
.max-h-\\[340px\\]{
  max-height: 340px;
}
.max-h-\\[380px\\]{
  max-height: 380px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[48px\\]{
  max-height: 48px;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[60\\%\\]{
  max-height: 60%;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[620px\\]{
  max-height: 620px;
}
.max-h-\\[680px\\]{
  max-height: 680px;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[80px\\]{
  max-height: 80px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[82vh\\]{
  max-height: 82vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[94vh\\]{
  max-height: 94vh;
}
.max-h-\\[95vh\\]{
  max-height: 95vh;
}
.max-h-\\[calc\\(100vh-10rem\\)\\]{
  max-height: calc(100vh - 10rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[260px\\]{
  min-height: 260px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[28px\\]{
  min-height: 28px;
}
.min-h-\\[297mm\\]{
  min-height: 297mm;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[32px\\]{
  min-height: 32px;
}
.min-h-\\[360px\\]{
  min-height: 360px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[380px\\]{
  min-height: 380px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[580px\\]{
  min-height: 580px;
}
.min-h-\\[600px\\]{
  min-height: 600px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[64px\\]{
  min-height: 64px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-120px\\)\\]{
  min-height: calc(100vh - 120px);
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[100vw\\]{
  width: 100vw;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[12px\\]{
  width: 12px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[136px\\]{
  width: 136px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[190px\\]{
  width: 190px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[380px\\]{
  width: 380px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[45vw\\]{
  width: 45vw;
}
.w-\\[48px\\]{
  width: 48px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[52px\\]{
  width: 52px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[55px\\]{
  width: 55px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[64px\\]{
  width: 64px;
}
.w-\\[65vw\\]{
  width: 65vw;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[82px\\]{
  width: 82px;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-\\[92px\\]{
  width: 92px;
}
.w-\\[95px\\]{
  width: 95px;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-\\[96vw\\]{
  width: 96vw;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-16{
  min-width: 4rem;
}
.min-w-20{
  min-width: 5rem;
}
.min-w-24{
  min-width: 6rem;
}
.min-w-28{
  min-width: 7rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[130px\\]{
  min-width: 130px;
}
.min-w-\\[1400px\\]{
  min-width: 1400px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[1800px\\]{
  min-width: 1800px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[190px\\]{
  min-width: 190px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[2200px\\]{
  min-width: 2200px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[28px\\]{
  min-width: 28px;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[32px\\]{
  min-width: 32px;
}
.min-w-\\[3rem\\]{
  min-width: 3rem;
}
.min-w-\\[4\\.5rem\\]{
  min-width: 4.5rem;
}
.min-w-\\[560px\\]{
  min-width: 560px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[700px\\]{
  min-width: 700px;
}
.min-w-\\[760px\\]{
  min-width: 760px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[88px\\]{
  min-width: 88px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[900px\\]{
  min-width: 900px;
}
.min-w-\\[92px\\]{
  min-width: 92px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-fit{
  min-width: fit-content;
}
.min-w-full{
  min-width: 100%;
}
.min-w-max{
  min-width: max-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[110px\\]{
  max-width: 110px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[155px\\]{
  max-width: 155px;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[1700px\\]{
  max-width: 1700px;
}
.max-w-\\[170px\\]{
  max-width: 170px;
}
.max-w-\\[1800px\\]{
  max-width: 1800px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[210mm\\]{
  max-width: 210mm;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[425px\\]{
  max-width: 425px;
}
.max-w-\\[45vw\\]{
  max-width: 45vw;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[540px\\]{
  max-width: 540px;
}
.max-w-\\[60px\\]{
  max-width: 60px;
}
.max-w-\\[65vw\\]{
  max-width: 65vw;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[80px\\]{
  max-width: 80px;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[85px\\]{
  max-width: 85px;
}
.max-w-\\[90px\\]{
  max-width: 90px;
}
.max-w-\\[935px\\]{
  max-width: 935px;
}
.max-w-\\[96vw\\]{
  max-width: 96vw;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.table-fixed{
  table-layout: fixed;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.origin-left{
  transform-origin: left;
}
.origin-right{
  transform-origin: right;
}
.origin-top{
  transform-origin: top;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2{
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-100\\%\\]{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-\\[20deg\\]{
  --tw-rotate: -20deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0{
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[fadeIn_0\\.25s_ease-out\\]{
  animation: fadeIn 0.25s ease-out;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-\\[spin_3s_linear_infinite\\]{
  animation: spin 3s linear infinite;
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-col-resize{
  cursor: col-resize;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-move{
  cursor: move;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-se-resize{
  cursor: se-resize;
}
.cursor-text{
  cursor: text;
}
.cursor-wait{
  cursor: wait;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-text{
  -webkit-user-select: text;
          user-select: text;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.columns-1{
  columns: 1;
}
.break-inside-avoid{
  page-break-inside: avoid;
  break-inside: avoid;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[1fr_88px_1fr\\]{
  grid-template-columns: 1fr 88px 1fr;
}
.grid-cols-\\[20px_1fr_auto_auto\\]{
  grid-template-columns: 20px 1fr auto auto;
}
.grid-cols-\\[70px_1fr_70px\\]{
  grid-template-columns: 70px 1fr 70px;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.-space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border));
}
.divide-border\\/50 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.5);
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg{
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-2xl{
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-md{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-\\[24px\\]{
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-t-lg{
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.rounded-t-none{
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-none{
  border-bottom-left-radius: 0px;
}
.rounded-br-none{
  border-bottom-right-radius: 0px;
}
.rounded-tl{
  border-top-left-radius: 0.25rem;
}
.rounded-tl-md{
  border-top-left-radius: calc(var(--radius) - 2px);
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[13px\\]{
  border-width: 13px;
}
.border-\\[14px\\]{
  border-width: 14px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[6px\\]{
  border-bottom-width: 6px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[10px\\]{
  border-left-width: 10px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-l-\\[8px\\]{
  border-left-width: 8px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[1px\\]{
  border-top-width: 1px;
}
.border-t-\\[6px\\]{
  border-top-width: 6px;
}
.border-t-\\[8px\\]{
  border-top-width: 8px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#1877F2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(24 119 242 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2AABEE\\]\\/50{
  border-color: rgb(42 171 238 / 0.5);
}
.border-\\[\\#FF0000\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ced0d4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(206 208 212 / var(--tw-border-opacity, 1));
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-100\\/50{
  border-color: rgb(254 243 199 / 0.5);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/50{
  border-color: rgb(253 230 138 / 0.5);
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/30{
  border-color: rgb(251 191 36 / 0.3);
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20{
  border-color: rgb(245 158 11 / 0.2);
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-500\\/40{
  border-color: rgb(245 158 11 / 0.4);
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/60{
  border-color: rgb(191 219 254 / 0.6);
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-400\\/30{
  border-color: rgb(96 165 250 / 0.3);
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-500\\/40{
  border-color: rgb(59 130 246 / 0.4);
}
.border-blue-500\\/50{
  border-color: rgb(59 130 246 / 0.5);
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-border{
  border-color: hsl(var(--border));
}
.border-border\\/30{
  border-color: hsl(var(--border) / 0.3);
}
.border-border\\/40{
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/5{
  border-color: hsl(var(--border) / 0.05);
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5);
}
.border-border\\/60{
  border-color: hsl(var(--border) / 0.6);
}
.border-border\\/70{
  border-color: hsl(var(--border) / 0.7);
}
.border-border\\/80{
  border-color: hsl(var(--border) / 0.8);
}
.border-card{
  border-color: hsl(var(--card));
}
.border-current{
  border-color: currentColor;
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/20{
  border-color: hsl(var(--destructive) / 0.2);
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/50{
  border-color: rgb(209 250 229 / 0.5);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/50{
  border-color: rgb(167 243 208 / 0.5);
}
.border-emerald-200\\/60{
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20{
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-foreground\\/50{
  border-color: hsl(var(--foreground) / 0.5);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/60{
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-400\\/30{
  border-color: rgb(74 222 128 / 0.3);
}
.border-green-400\\/40{
  border-color: rgb(74 222 128 / 0.4);
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-500\\/20{
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-500\\/40{
  border-color: rgb(34 197 94 / 0.4);
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/50{
  border-color: rgb(224 231 255 / 0.5);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/20{
  border-color: rgb(199 210 254 / 0.2);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-300\\/30{
  border-color: rgb(165 180 252 / 0.3);
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-400\\/40{
  border-color: rgb(129 140 248 / 0.4);
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20{
  border-color: rgb(99 102 241 / 0.2);
}
.border-indigo-500\\/30{
  border-color: rgb(99 102 241 / 0.3);
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-600\\/40{
  border-color: rgb(79 70 229 / 0.4);
}
.border-indigo-700\\/50{
  border-color: rgb(67 56 202 / 0.5);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-lime-200{
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity, 1));
}
.border-lime-600{
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity, 1));
}
.border-muted-foreground\\/50{
  border-color: hsl(var(--muted-foreground) / 0.5);
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-200\\/50{
  border-color: rgb(254 215 170 / 0.5);
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-orange-500\\/20{
  border-color: rgb(249 115 22 / 0.2);
}
.border-orange-500\\/50{
  border-color: rgb(249 115 22 / 0.5);
}
.border-orange-600{
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-pink-100{
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-500\\/20{
  border-color: rgb(236 72 153 / 0.2);
}
.border-pink-600{
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/20{
  border-color: hsl(var(--primary) / 0.2);
}
.border-primary\\/30{
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-200\\/50{
  border-color: rgb(233 213 255 / 0.5);
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-400\\/30{
  border-color: rgb(192 132 252 / 0.3);
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-500\\/20{
  border-color: rgb(168 85 247 / 0.2);
}
.border-purple-500\\/40{
  border-color: rgb(168 85 247 / 0.4);
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-100\\/50{
  border-color: rgb(254 226 226 / 0.5);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-200\\/50{
  border-color: rgb(254 202 202 / 0.5);
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-400\\/40{
  border-color: rgb(248 113 113 / 0.4);
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20{
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-red-600\\/30{
  border-color: rgb(220 38 38 / 0.3);
}
.border-red-700{
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.border-red-900\\/30{
  border-color: rgb(127 29 29 / 0.3);
}
.border-red-900\\/50{
  border-color: rgb(127 29 29 / 0.5);
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.border-sky-400{
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.border-sky-500{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.border-sky-500\\/20{
  border-color: rgb(14 165 233 / 0.2);
}
.border-sky-500\\/30{
  border-color: rgb(14 165 233 / 0.3);
}
.border-sky-500\\/60{
  border-color: rgb(14 165 233 / 0.6);
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-100\\/50{
  border-color: rgb(241 245 249 / 0.5);
}
.border-slate-100\\/60{
  border-color: rgb(241 245 249 / 0.6);
}
.border-slate-100\\/80{
  border-color: rgb(241 245 249 / 0.8);
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/40{
  border-color: rgb(226 232 240 / 0.4);
}
.border-slate-200\\/50{
  border-color: rgb(226 232 240 / 0.5);
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-400{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.border-slate-400\\/30{
  border-color: rgb(148 163 184 / 0.3);
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity, 1));
}
.border-slate-500\\/20{
  border-color: rgb(100 116 139 / 0.2);
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-600\\/50{
  border-color: rgb(71 85 105 / 0.5);
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/50{
  border-color: rgb(51 65 85 / 0.5);
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-slate-950{
  --tw-border-opacity: 1;
  border-color: rgb(2 6 23 / var(--tw-border-opacity, 1));
}
.border-teal-100{
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity, 1));
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}
.border-teal-400{
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.border-teal-600{
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-violet-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/20{
  border-color: rgb(139 92 246 / 0.2);
}
.border-violet-600{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-violet-700{
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/80{
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity, 1));
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-yellow-400\\/40{
  border-color: rgb(250 204 21 / 0.4);
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/20{
  border-color: rgb(234 179 8 / 0.2);
}
.border-yellow-600{
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity, 1));
}
.border-zinc-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-b-transparent{
  border-bottom-color: transparent;
}
.border-l-amber-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-emerald-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-l-gray-800{
  --tw-border-opacity: 1;
  border-left-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-l-green-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-l-pink-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.border-l-primary{
  border-left-color: hsl(var(--primary));
}
.border-l-purple-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-l-red-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-l-red-600{
  --tw-border-opacity: 1;
  border-left-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-l-white{
  --tw-border-opacity: 1;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-t-amber-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-t-primary{
  border-top-color: hsl(var(--primary));
}
.border-t-purple-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-t-red-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-t-sky-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-violet-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#071633\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(7 22 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10b981\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16a34a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1877F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 119 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d4ed8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d9bf0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 155 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563eb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2AABEE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 171 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2AABEE\\]\\/10{
  background-color: rgb(42 171 238 / 0.1);
}
.bg-\\[\\#3b82f6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#60a5fa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6366f1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7c3aed\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8b5cf6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF0000\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b91c1c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#bfdbfe\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ca8a04\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#cbd5e1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#cfd9de\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(207 217 222 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e1f3fb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(225 243 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eab308\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ef4444\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#efeae2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 234 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f4f6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f43f5e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f97316\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#facc15\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fef08a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.bg-amber-200\\/40{
  background-color: rgb(253 230 138 / 0.4);
}
.bg-amber-200\\/80{
  background-color: rgb(253 230 138 / 0.8);
}
.bg-amber-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/20{
  background-color: rgb(255 251 235 / 0.2);
}
.bg-amber-50\\/30{
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50{
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/55{
  background-color: rgb(255 251 235 / 0.55);
}
.bg-amber-50\\/70{
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80{
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15{
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-500\\/5{
  background-color: rgb(245 158 11 / 0.05);
}
.bg-amber-500\\/90{
  background-color: rgb(245 158 11 / 0.9);
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-background\\/50{
  background-color: hsl(var(--background) / 0.5);
}
.bg-background\\/60{
  background-color: hsl(var(--background) / 0.6);
}
.bg-background\\/80{
  background-color: hsl(var(--background) / 0.8);
}
.bg-background\\/90{
  background-color: hsl(var(--background) / 0.9);
}
.bg-background\\/95{
  background-color: hsl(var(--background) / 0.95);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/5{
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/95{
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/50{
  background-color: rgb(219 234 254 / 0.5);
}
.bg-blue-200\\/40{
  background-color: rgb(191 219 254 / 0.4);
}
.bg-blue-200\\/60{
  background-color: rgb(191 219 254 / 0.6);
}
.bg-blue-200\\/75{
  background-color: rgb(191 219 254 / 0.75);
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-400\\/20{
  background-color: rgb(96 165 250 / 0.2);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30{
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-blue-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-50\\/70{
  background-color: rgb(239 246 255 / 0.7);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/20{
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-500\\/5{
  background-color: rgb(59 130 246 / 0.05);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/10{
  background-color: rgb(37 99 235 / 0.1);
}
.bg-blue-600\\/90{
  background-color: rgb(37 99 235 / 0.9);
}
.bg-blue-900\\/40{
  background-color: rgb(30 58 138 / 0.4);
}
.bg-blue-900\\/50{
  background-color: rgb(30 58 138 / 0.5);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-card\\/50{
  background-color: hsl(var(--card) / 0.5);
}
.bg-card\\/80{
  background-color: hsl(var(--card) / 0.8);
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-200\\/60{
  background-color: rgb(165 243 252 / 0.6);
}
.bg-cyan-200\\/75{
  background-color: rgb(165 243 252 / 0.75);
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-destructive\\/10{
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-200\\/60{
  background-color: rgb(167 243 208 / 0.6);
}
.bg-emerald-200\\/75{
  background-color: rgb(167 243 208 / 0.75);
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/55{
  background-color: rgb(236 253 245 / 0.55);
}
.bg-emerald-50\\/60{
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70{
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/80{
  background-color: rgb(16 185 129 / 0.8);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-700{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-foreground\\/10{
  background-color: hsl(var(--foreground) / 0.1);
}
.bg-foreground\\/20{
  background-color: hsl(var(--foreground) / 0.2);
}
.bg-foreground\\/30{
  background-color: hsl(var(--foreground) / 0.3);
}
.bg-foreground\\/80{
  background-color: hsl(var(--foreground) / 0.8);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/30{
  background-color: rgb(249 250 251 / 0.3);
}
.bg-gray-50\\/50{
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/60{
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/80{
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/5{
  background-color: rgb(34 197 94 / 0.05);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100\\/60{
  background-color: rgb(224 231 255 / 0.6);
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200\\/80{
  background-color: rgb(199 210 254 / 0.8);
}
.bg-indigo-300{
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/20{
  background-color: rgb(238 242 255 / 0.2);
}
.bg-indigo-50\\/30{
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-50\\/50{
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/60{
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10{
  background-color: rgb(99 102 241 / 0.1);
}
.bg-indigo-500\\/20{
  background-color: rgb(99 102 241 / 0.2);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-lime-50{
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity, 1));
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted-foreground{
  background-color: hsl(var(--muted-foreground));
}
.bg-muted-foreground\\/20{
  background-color: hsl(var(--muted-foreground) / 0.2);
}
.bg-muted-foreground\\/30{
  background-color: hsl(var(--muted-foreground) / 0.3);
}
.bg-muted\\/10{
  background-color: hsl(var(--muted) / 0.1);
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/45{
  background-color: hsl(var(--muted) / 0.45);
}
.bg-muted\\/5{
  background-color: hsl(var(--muted) / 0.05);
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60{
  background-color: hsl(var(--muted) / 0.6);
}
.bg-muted\\/80{
  background-color: hsl(var(--muted) / 0.8);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-200\\/60{
  background-color: rgb(251 207 232 / 0.6);
}
.bg-pink-200\\/75{
  background-color: rgb(251 207 232 / 0.75);
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-50\\/70{
  background-color: rgb(253 242 248 / 0.7);
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-pink-500\\/10{
  background-color: rgb(236 72 153 / 0.1);
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-police-navy\\/10{
  background-color: hsl(var(--police-navy) / 0.1);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary-foreground\\/10{
  background-color: hsl(var(--primary-foreground) / 0.1);
}
.bg-primary-foreground\\/20{
  background-color: hsl(var(--primary-foreground) / 0.2);
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/15{
  background-color: hsl(var(--primary) / 0.15);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10{
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-500\\/20{
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-500\\/5{
  background-color: rgb(168 85 247 / 0.05);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-200\\/60{
  background-color: rgb(254 202 202 / 0.6);
}
.bg-red-200\\/75{
  background-color: rgb(254 202 202 / 0.75);
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/20{
  background-color: rgb(254 242 242 / 0.2);
}
.bg-red-50\\/30{
  background-color: rgb(254 242 242 / 0.3);
}
.bg-red-50\\/40{
  background-color: rgb(254 242 242 / 0.4);
}
.bg-red-50\\/50{
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-50\\/55{
  background-color: rgb(254 242 242 / 0.55);
}
.bg-red-50\\/60{
  background-color: rgb(254 242 242 / 0.6);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/90{
  background-color: rgb(220 38 38 / 0.9);
}
.bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-red-900{
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40{
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10{
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-secondary\\/10{
  background-color: hsl(var(--secondary) / 0.1);
}
.bg-secondary\\/20{
  background-color: hsl(var(--secondary) / 0.2);
}
.bg-secondary\\/30{
  background-color: hsl(var(--secondary) / 0.3);
}
.bg-secondary\\/5{
  background-color: hsl(var(--secondary) / 0.05);
}
.bg-secondary\\/50{
  background-color: hsl(var(--secondary) / 0.5);
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-100\\/50{
  background-color: rgb(224 242 254 / 0.5);
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-sky-500\\/20{
  background-color: rgb(14 165 233 / 0.2);
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/50{
  background-color: rgb(241 245 249 / 0.5);
}
.bg-slate-100\\/70{
  background-color: rgb(241 245 249 / 0.7);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/70{
  background-color: rgb(226 232 240 / 0.7);
}
.bg-slate-200\\/80{
  background-color: rgb(226 232 240 / 0.8);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/30{
  background-color: rgb(248 250 252 / 0.3);
}
.bg-slate-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/10{
  background-color: rgb(100 116 139 / 0.1);
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/50{
  background-color: rgb(30 41 59 / 0.5);
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/40{
  background-color: rgb(15 23 42 / 0.4);
}
.bg-slate-900\\/60{
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-slate-950\\/50{
  background-color: rgb(2 6 23 / 0.5);
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-400{
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-50\\/40{
  background-color: rgb(240 253 250 / 0.4);
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-200\\/40{
  background-color: rgb(221 214 254 / 0.4);
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/40{
  background-color: rgb(245 243 255 / 0.4);
}
.bg-violet-50\\/50{
  background-color: rgb(245 243 255 / 0.5);
}
.bg-violet-50\\/60{
  background-color: rgb(245 243 255 / 0.6);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25{
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-white\\/\\[0\\.08\\]{
  background-color: rgb(255 255 255 / 0.08);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200\\/40{
  background-color: rgb(254 240 138 / 0.4);
}
.bg-yellow-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400\\/5{
  background-color: rgb(250 204 21 / 0.05);
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50\\/40{
  background-color: rgb(254 252 232 / 0.4);
}
.bg-yellow-50\\/60{
  background-color: rgb(254 252 232 / 0.6);
}
.bg-yellow-50\\/80{
  background-color: rgb(254 252 232 / 0.8);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10{
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/20{
  background-color: rgb(234 179 8 / 0.2);
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[url\\(\\'https\\:\\/\\/grainy-gradients\\.vercel\\.app\\/noise\\.svg\\'\\)\\]{
  background-image: url('https://grainy-gradients.vercel.app/noise.svg');
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tl{
  background-image: linear-gradient(to top left, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#833AB4\\]{
  --tw-gradient-from: #833AB4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(131 58 180 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FCAF45\\]{
  --tw-gradient-from: #FCAF45 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 175 69 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/50{
  --tw-gradient-from: rgb(255 251 235 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/60{
  --tw-gradient-from: rgb(255 251 235 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500\\/5{
  --tw-gradient-from: rgb(245 158 11 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600{
  --tw-gradient-from: #d97706 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-800{
  --tw-gradient-from: #92400e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(146 64 14 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-background{
  --tw-gradient-from: hsl(var(--background)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--background) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black{
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/60{
  --tw-gradient-from: rgb(0 0 0 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70{
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400\\/10{
  --tw-gradient-from: rgb(96 165 250 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400\\/20{
  --tw-gradient-from: rgb(96 165 250 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/60{
  --tw-gradient-from: rgb(239 246 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/80{
  --tw-gradient-from: rgb(239 246 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/10{
  --tw-gradient-from: rgb(59 130 246 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/5{
  --tw-gradient-from: rgb(59 130 246 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-card{
  --tw-gradient-from: hsl(var(--card)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--card) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/50{
  --tw-gradient-from: rgb(236 253 245 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/60{
  --tw-gradient-from: rgb(236 253 245 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500\\/10{
  --tw-gradient-from: rgb(16 185 129 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600{
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-300{
  --tw-gradient-from: #d1d5db var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900{
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/10{
  --tw-gradient-from: rgb(34 197 94 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600\\/10{
  --tw-gradient-from: rgb(22 163 74 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/40{
  --tw-gradient-from: rgb(238 242 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80{
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500\\/10{
  --tw-gradient-from: rgb(99 102 241 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-muted\\/50{
  --tw-gradient-from: hsl(var(--muted) / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--muted) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400{
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500\\/10{
  --tw-gradient-from: rgb(249 115 22 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600{
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50\\/60{
  --tw-gradient-from: rgb(253 242 248 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary{
  --tw-gradient-from: hsl(var(--primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/10{
  --tw-gradient-from: hsl(var(--primary) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/5{
  --tw-gradient-from: hsl(var(--primary) / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100{
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400{
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500\\/10{
  --tw-gradient-from: rgb(168 85 247 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500\\/15{
  --tw-gradient-from: rgb(239 68 68 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500\\/5{
  --tw-gradient-from: rgb(239 68 68 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600{
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-700{
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-700\\/10{
  --tw-gradient-from: rgb(185 28 28 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500\\/10{
  --tw-gradient-from: rgb(244 63 94 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-600{
  --tw-gradient-from: #e11d48 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(225 29 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400{
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500{
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500\\/10{
  --tw-gradient-from: rgb(14 165 233 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500\\/15{
  --tw-gradient-from: rgb(14 165 233 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-600{
  --tw-gradient-from: #0284c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 132 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-100{
  --tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-300{
  --tw-gradient-from: #cbd5e1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(203 213 225 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-400{
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-600{
  --tw-gradient-from: #475569 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-700{
  --tw-gradient-from: #334155 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-800{
  --tw-gradient-from: #1e293b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 41 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-100{
  --tw-gradient-from: #ede9fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 233 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400{
  --tw-gradient-from: #a78bfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50{
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/10{
  --tw-gradient-from: rgb(139 92 246 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/5{
  --tw-gradient-from: rgb(139 92 246 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600\\/10{
  --tw-gradient-from: rgb(124 58 237 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-700{
  --tw-gradient-from: #6d28d9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 40 217 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400{
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-50\\/50{
  --tw-gradient-from: rgb(254 252 232 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 252 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500{
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#E1306C\\]{
  --tw-gradient-to: rgb(225 48 108 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E1306C var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FD1D1D\\]{
  --tw-gradient-to: rgb(253 29 29 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FD1D1D var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500\\/5{
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(59 130 246 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-card{
  --tw-gradient-to: hsl(var(--card) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--card)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-400{
  --tw-gradient-to: rgb(156 163 175 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9ca3af var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500{
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6366f1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/5{
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary) / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500\\/5{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(168 85 247 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-500{
  --tw-gradient-to: rgb(244 63 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f43f5e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-600{
  --tw-gradient-to: rgb(225 29 72 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #e11d48 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-sky-500\\/5{
  --tw-gradient-to: rgb(14 165 233 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(14 165 233 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-800{
  --tw-gradient-to: rgb(30 41 59 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e293b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/5{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-zinc-950{
  --tw-gradient-to: rgb(9 9 11 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #09090b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#833AB4\\]{
  --tw-gradient-to: #833AB4 var(--tw-gradient-to-position);
}
.to-\\[\\#F56040\\]{
  --tw-gradient-to: #F56040 var(--tw-gradient-to-position);
}
.to-amber-400{
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}
.to-amber-700{
  --tw-gradient-to: #b45309 var(--tw-gradient-to-position);
}
.to-amber-900{
  --tw-gradient-to: #78350f var(--tw-gradient-to-position);
}
.to-black{
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.to-blue-50\\/30{
  --tw-gradient-to: rgb(239 246 255 / 0.3) var(--tw-gradient-to-position);
}
.to-blue-500{
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-500\\/5{
  --tw-gradient-to: rgb(59 130 246 / 0.05) var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-card\\/90{
  --tw-gradient-to: hsl(var(--card) / 0.9) var(--tw-gradient-to-position);
}
.to-cyan-50\\/40{
  --tw-gradient-to: rgb(236 254 255 / 0.4) var(--tw-gradient-to-position);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600{
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-100{
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-500\\/10{
  --tw-gradient-to: rgb(16 185 129 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-500\\/5{
  --tw-gradient-to: rgb(16 185 129 / 0.05) var(--tw-gradient-to-position);
}
.to-emerald-700{
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}
.to-fuchsia-600{
  --tw-gradient-to: #c026d3 var(--tw-gradient-to-position);
}
.to-gray-300{
  --tw-gradient-to: #d1d5db var(--tw-gradient-to-position);
}
.to-green-50\\/40{
  --tw-gradient-to: rgb(240 253 244 / 0.4) var(--tw-gradient-to-position);
}
.to-green-700{
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}
.to-indigo-100{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-50{
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/80{
  --tw-gradient-to: rgb(238 242 255 / 0.8) var(--tw-gradient-to-position);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-500\\/10{
  --tw-gradient-to: rgb(99 102 241 / 0.1) var(--tw-gradient-to-position);
}
.to-indigo-500\\/20{
  --tw-gradient-to: rgb(99 102 241 / 0.2) var(--tw-gradient-to-position);
}
.to-indigo-500\\/5{
  --tw-gradient-to: rgb(99 102 241 / 0.05) var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-muted\\/30{
  --tw-gradient-to: hsl(var(--muted) / 0.3) var(--tw-gradient-to-position);
}
.to-orange-400{
  --tw-gradient-to: #fb923c var(--tw-gradient-to-position);
}
.to-orange-50\\/40{
  --tw-gradient-to: rgb(255 247 237 / 0.4) var(--tw-gradient-to-position);
}
.to-orange-50\\/50{
  --tw-gradient-to: rgb(255 247 237 / 0.5) var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-orange-700{
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}
.to-pink-100{
  --tw-gradient-to: #fce7f3 var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-500\\/10{
  --tw-gradient-to: rgb(236 72 153 / 0.1) var(--tw-gradient-to-position);
}
.to-pink-600{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-primary\\/10{
  --tw-gradient-to: hsl(var(--primary) / 0.1) var(--tw-gradient-to-position);
}
.to-primary\\/5{
  --tw-gradient-to: hsl(var(--primary) / 0.05) var(--tw-gradient-to-position);
}
.to-primary\\/60{
  --tw-gradient-to: hsl(var(--primary) / 0.6) var(--tw-gradient-to-position);
}
.to-primary\\/80{
  --tw-gradient-to: hsl(var(--primary) / 0.8) var(--tw-gradient-to-position);
}
.to-primary\\/90{
  --tw-gradient-to: hsl(var(--primary) / 0.9) var(--tw-gradient-to-position);
}
.to-purple-50\\/30{
  --tw-gradient-to: rgb(250 245 255 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-700{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-red-50\\/20{
  --tw-gradient-to: rgb(254 242 242 / 0.2) var(--tw-gradient-to-position);
}
.to-red-500{
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-500\\/10{
  --tw-gradient-to: rgb(239 68 68 / 0.1) var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-red-700{
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}
.to-rose-50\\/40{
  --tw-gradient-to: rgb(255 241 242 / 0.4) var(--tw-gradient-to-position);
}
.to-rose-500\\/10{
  --tw-gradient-to: rgb(244 63 94 / 0.1) var(--tw-gradient-to-position);
}
.to-rose-500\\/5{
  --tw-gradient-to: rgb(244 63 94 / 0.05) var(--tw-gradient-to-position);
}
.to-rose-700{
  --tw-gradient-to: #be123c var(--tw-gradient-to-position);
}
.to-secondary{
  --tw-gradient-to: hsl(var(--secondary)) var(--tw-gradient-to-position);
}
.to-sky-400{
  --tw-gradient-to: #38bdf8 var(--tw-gradient-to-position);
}
.to-sky-50{
  --tw-gradient-to: #f0f9ff var(--tw-gradient-to-position);
}
.to-sky-600{
  --tw-gradient-to: #0284c7 var(--tw-gradient-to-position);
}
.to-sky-700{
  --tw-gradient-to: #0369a1 var(--tw-gradient-to-position);
}
.to-slate-200{
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-50{
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-slate-50\\/30{
  --tw-gradient-to: rgb(248 250 252 / 0.3) var(--tw-gradient-to-position);
}
.to-slate-50\\/50{
  --tw-gradient-to: rgb(248 250 252 / 0.5) var(--tw-gradient-to-position);
}
.to-slate-600{
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}
.to-slate-700{
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.to-slate-800{
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-slate-900{
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-50{
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-50\\/50{
  --tw-gradient-to: rgb(245 243 255 / 0.5) var(--tw-gradient-to-position);
}
.to-violet-500{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-500\\/5{
  --tw-gradient-to: rgb(139 92 246 / 0.05) var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-violet-700{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-white\\/70{
  --tw-gradient-to: rgb(255 255 255 / 0.7) var(--tw-gradient-to-position);
}
.to-yellow-50\\/10{
  --tw-gradient-to: rgb(254 252 232 / 0.1) var(--tw-gradient-to-position);
}
.to-yellow-700{
  --tw-gradient-to: #a16207 var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-\\[\\#2AABEE\\]{
  fill: #2AABEE;
}
.fill-amber-100{
  fill: #fef3c7;
}
.fill-black{
  fill: #000;
}
.fill-blue-50{
  fill: #eff6ff;
}
.fill-blue-500{
  fill: #3b82f6;
}
.fill-current{
  fill: currentColor;
}
.fill-indigo-50{
  fill: #eef2ff;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.fill-red-100{
  fill: #fee2e2;
}
.fill-red-50{
  fill: #fef2f2;
}
.fill-red-500{
  fill: #ef4444;
}
.fill-red-700{
  fill: #b91c1c;
}
.fill-white{
  fill: #fff;
}
.fill-yellow-100{
  fill: #fef9c3;
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-top{
  object-position: top;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.p-\\[20mm\\]{
  padding: 20mm;
}
.p-\\[25mm_20mm\\]{
  padding: 25mm 20mm;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-\\[3px\\]{
  padding: 3px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20mm\\]{
  padding-left: 20mm;
  padding-right: 20mm;
}
.px-\\[70px\\]{
  padding-left: 70px;
  padding-right: 70px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-28{
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[7px\\]{
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-3\\.5{
  padding-bottom: 0.875rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-1\\.5{
  padding-left: 0.375rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-16{
  padding-left: 4rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-20{
  padding-left: 5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-28{
  padding-right: 7rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[56\\.25\\%\\]{
  padding-top: 56.25%;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-heading{
  font-family: Oswald, sans-serif;
}
.font-mono{
  font-family: JetBrains Mono, monospace;
}
.font-sans{
  font-family: Inter, sans-serif;
}
.font-serif{
  font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14\\.2px\\]{
  font-size: 14.2px;
}
.text-\\[14\\.5px\\]{
  font-size: 14.5px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15\\.5px\\]{
  font-size: 15.5px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[6px\\]{
  font-size: 6px;
}
.text-\\[7px\\]{
  font-size: 7px;
}
.text-\\[8\\.5px\\]{
  font-size: 8.5px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9\\.5px\\]{
  font-size: 9.5px;
}
.text-\\[9pt\\]{
  font-size: 9pt;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-\\[1\\.7\\]{
  line-height: 1.7;
}
.leading-\\[19px\\]{
  line-height: 19px;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[\\.1em\\]{
  letter-spacing: .1em;
}
.tracking-\\[0\\.1em\\]{
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#00a884\\]{
  --tw-text-opacity: 1;
  color: rgb(0 168 132 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00ba7c\\]{
  --tw-text-opacity: 1;
  color: rgb(0 186 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#050505\\]{
  --tw-text-opacity: 1;
  color: rgb(5 5 5 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f1419\\]{
  --tw-text-opacity: 1;
  color: rgb(15 20 25 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f172a\\]{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#111b21\\]{
  --tw-text-opacity: 1;
  color: rgb(17 27 33 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1877F2\\]{
  --tw-text-opacity: 1;
  color: rgb(24 119 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1DA1F2\\]{
  --tw-text-opacity: 1;
  color: rgb(29 161 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d9bf0\\]{
  --tw-text-opacity: 1;
  color: rgb(29 155 240 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2AABEE\\]{
  --tw-text-opacity: 1;
  color: rgb(42 171 238 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2AABEE\\]\\/40{
  color: rgb(42 171 238 / 0.4);
}
.text-\\[\\#536471\\]{
  --tw-text-opacity: 1;
  color: rgb(83 100 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#54656f\\]{
  --tw-text-opacity: 1;
  color: rgb(84 101 111 / var(--tw-text-opacity, 1));
}
.text-\\[\\#65676b\\]{
  --tw-text-opacity: 1;
  color: rgb(101 103 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667781\\]{
  --tw-text-opacity: 1;
  color: rgb(102 119 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E4405F\\]{
  --tw-text-opacity: 1;
  color: rgb(228 64 95 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF0000\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-50{
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-500\\/70{
  color: rgb(245 158 11 / 0.7);
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-700\\/80{
  color: rgb(180 83 9 / 0.8);
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-background{
  color: hsl(var(--background));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-500\\/70{
  color: rgb(59 130 246 / 0.7);
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-border{
  color: hsl(var(--border));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-500\\/50{
  color: rgb(16 185 129 / 0.5);
}
.text-emerald-500\\/70{
  color: rgb(16 185 129 / 0.7);
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-foreground\\/70{
  color: hsl(var(--foreground) / 0.7);
}
.text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8);
}
.text-foreground\\/85{
  color: hsl(var(--foreground) / 0.85);
}
.text-foreground\\/90{
  color: hsl(var(--foreground) / 0.9);
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-400\\/80{
  color: rgb(156 163 175 / 0.8);
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-500\\/0{
  color: rgb(34 197 94 / 0);
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-100{
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-200{
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-50{
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-lime-600{
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity, 1));
}
.text-lime-700{
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-muted-foreground\\/30{
  color: hsl(var(--muted-foreground) / 0.3);
}
.text-muted-foreground\\/40{
  color: hsl(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/50{
  color: hsl(var(--muted-foreground) / 0.5);
}
.text-muted-foreground\\/60{
  color: hsl(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-muted-foreground\\/80{
  color: hsl(var(--muted-foreground) / 0.8);
}
.text-muted\\/40{
  color: hsl(var(--muted) / 0.4);
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-500\\/60{
  color: rgb(249 115 22 / 0.6);
}
.text-orange-500\\/70{
  color: rgb(249 115 22 / 0.7);
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-300{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-police-navy{
  color: hsl(var(--police-navy));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-primary-foreground\\/70{
  color: hsl(var(--primary-foreground) / 0.7);
}
.text-primary\\/70{
  color: hsl(var(--primary) / 0.7);
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-600\\/80{
  color: rgb(147 51 234 / 0.8);
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-400\\/80{
  color: rgb(248 113 113 / 0.8);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-500\\/80{
  color: rgb(239 68 68 / 0.8);
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary{
  color: hsl(var(--secondary));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-400{
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}
.text-sky-400\\/50{
  color: rgb(56 189 248 / 0.5);
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-300{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-500\\/70{
  color: rgb(139 92 246 / 0.7);
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/30{
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-white\\/95{
  color: rgb(255 255 255 / 0.95);
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-zinc-400{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-900{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.decoration-blue-300\\/50{
  text-decoration-color: rgb(147 197 253 / 0.5);
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-white\\/20::placeholder{
  color: rgb(255 255 255 / 0.2);
}
.placeholder-white\\/60::placeholder{
  color: rgb(255 255 255 / 0.6);
}
.accent-orange-600{
  accent-color: #ea580c;
}
.accent-yellow-600{
  accent-color: #ca8a04;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-15{
  opacity: 0.15;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-5{
  opacity: 0.05;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-85{
  opacity: 0.85;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-8px_0_28px_-12px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\]{
  --tw-shadow: -8px 0 28px -12px rgba(15,23,42,0.18);
  --tw-shadow-colored: -8px 0 28px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(225\\2c 48\\2c 108\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 12px rgba(225,48,108,0.3);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 0 15px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c 0_0_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 0 20px rgba(0,0,0,0.1),0 0 5px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color), 0 0 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_70px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.32\\)\\]{
  --tw-shadow: 0 18px 70px rgba(15,23,42,0.32);
  --tw-shadow-colored: 0 18px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 1px 3px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 4px 0 24px rgba(0,0,0,0.02);
  --tw-shadow-colored: 4px 0 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-100{
  --tw-shadow-color: #fef3c7;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-200{
  --tw-shadow-color: #fde68a;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-400\\/50{
  --tw-shadow-color: rgb(251 191 36 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/20{
  --tw-shadow-color: rgb(245 158 11 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/40{
  --tw-shadow-color: rgb(0 0 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-200{
  --tw-shadow-color: #bfdbfe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/20{
  --tw-shadow-color: rgb(30 58 138 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-100{
  --tw-shadow-color: #d1fae5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-200{
  --tw-shadow-color: #a7f3d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/50{
  --tw-shadow-color: rgb(52 211 153 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/20{
  --tw-shadow-color: rgb(16 185 129 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-100{
  --tw-shadow-color: #ffedd5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/30{
  --tw-shadow-color: rgb(249 115 22 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/20{
  --tw-shadow-color: hsl(var(--primary) / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/30{
  --tw-shadow-color: hsl(var(--primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-200{
  --tw-shadow-color: #fecaca;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/30{
  --tw-shadow-color: rgb(239 68 68 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-700\\/30{
  --tw-shadow-color: rgb(185 28 28 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-400\\/50{
  --tw-shadow-color: rgb(251 113 133 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-amber-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-amber-300\\/50{
  --tw-ring-color: rgb(252 211 77 / 0.5);
}
.ring-amber-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-blue-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-blue-50{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 246 255 / var(--tw-ring-opacity, 1));
}
.ring-blue-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.ring-blue-500\\/20{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.ring-border{
  --tw-ring-color: hsl(var(--border));
}
.ring-card{
  --tw-ring-color: hsl(var(--card));
}
.ring-cyan-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(207 250 254 / var(--tw-ring-opacity, 1));
}
.ring-cyan-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity, 1));
}
.ring-emerald-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(110 231 183 / var(--tw-ring-opacity, 1));
}
.ring-gray-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}
.ring-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.ring-green-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 252 231 / var(--tw-ring-opacity, 1));
}
.ring-green-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-green-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.ring-green-500\\/20{
  --tw-ring-color: rgb(34 197 94 / 0.2);
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-indigo-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500\\/10{
  --tw-ring-color: rgb(99 102 241 / 0.1);
}
.ring-lime-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 249 157 / var(--tw-ring-opacity, 1));
}
.ring-orange-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 237 213 / var(--tw-ring-opacity, 1));
}
.ring-orange-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.ring-orange-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}
.ring-orange-500\\/20{
  --tw-ring-color: rgb(249 115 22 / 0.2);
}
.ring-pink-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 231 243 / var(--tw-ring-opacity, 1));
}
.ring-pink-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity, 1));
}
.ring-primary\\/30{
  --tw-ring-color: hsl(var(--primary) / 0.3);
}
.ring-purple-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 232 255 / var(--tw-ring-opacity, 1));
}
.ring-purple-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.ring-red-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 226 226 / var(--tw-ring-opacity, 1));
}
.ring-red-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-red-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.ring-red-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.ring-red-500\\/20{
  --tw-ring-color: rgb(239 68 68 / 0.2);
}
.ring-red-500\\/30{
  --tw-ring-color: rgb(239 68 68 / 0.3);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-rose-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity, 1));
}
.ring-sky-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-sky-500\\/20{
  --tw-ring-color: rgb(14 165 233 / 0.2);
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-teal-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 251 241 / var(--tw-ring-opacity, 1));
}
.ring-teal-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}
.ring-teal-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-violet-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-yellow-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 240 138 / var(--tw-ring-opacity, 1));
}
.ring-yellow-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity, 1));
}
.ring-yellow-500\\/20{
  --tw-ring-color: rgb(234 179 8 / 0.2);
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.ring-offset-white{
  --tw-ring-offset-color: #fff;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\]{
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md{
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-100{
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.contrast-150{
  --tw-contrast: contrast(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\]{
  --tw-drop-shadow: drop-shadow(0 1px 3px rgba(0,0,0,0.8));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-150{
  transition-delay: 150ms;
}
.delay-75{
  transition-delay: 75ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in{
  --tw-enter-scale: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-2{
  --tw-enter-translate-y: 0.5rem;
}
.slide-in-from-bottom-4{
  --tw-enter-translate-y: 1rem;
}
.slide-in-from-right{
  --tw-enter-translate-x: 100%;
}
.slide-in-from-right-2{
  --tw-enter-translate-x: 0.5rem;
}
.slide-in-from-top-1{
  --tw-enter-translate-y: -0.25rem;
}
.slide-in-from-top-2{
  --tw-enter-translate-y: -0.5rem;
}
.duration-100{
  animation-duration: 100ms;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.duration-700{
  animation-duration: 700ms;
}
.delay-150{
  animation-delay: 150ms;
}
.delay-75{
  animation-delay: 75ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.\\!paused{
  animation-play-state: paused !important;
}
.paused{
  animation-play-state: paused;
}
/* Hide scrollbar but keep functionality */
.scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
.scrollbar-hide::-webkit-scrollbar {
        display: none;
    }
/* Safe area padding for notched devices */
/* Prevent text selection on interactive elements */
/* Hardware accelerated animations */
/* Mobile-friendly text truncation */
/* Custom Scrollbar for Sidebar/Dark Areas */
.custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 8px;
    }
.custom-scrollbar::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.03);
    }
.custom-scrollbar::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
    }
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.3);
    }
/* Dark variant for navy/dark backgrounds */
.custom-scrollbar-dark::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
.custom-scrollbar-dark::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
    }
.custom-scrollbar-dark::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.25);
        border-radius: 10px;
    }
.custom-scrollbar-dark::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.4);
    }
/* Subtle fade-in animation */
.animate-fade-in {
        animation: fadeIn 0.3s ease-out forwards;
    }
@keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
/* Slide-in from left (for sidebar) */
@keyframes slideInLeft {
        from {
            transform: translateX(-100%);
        }
        to {
            transform: translateX(0);
        }
    }
/* Pulse for status indicators */
.animate-progress-indeterminate {
        animation: progress-indeterminate 1.5s infinite linear;
        transform-origin: 0% 50%;
    }
@keyframes progress-indeterminate {
        0% {
            transform: translateX(0) scaleX(0);
        }

        40% {
            transform: translateX(0) scaleX(0.4);
        }

        100% {
            transform: translateX(100%) scaleX(0.5);
        }
    }
.\\[animation-delay\\:0ms\\]{
  animation-delay: 0ms;
}
.\\[animation-delay\\:120ms\\]{
  animation-delay: 120ms;
}
.\\[animation-delay\\:240ms\\]{
  animation-delay: 240ms;
}
.\\[column-fill\\:_balance\\]{
  column-fill: balance;
}
.\\[column-gap\\:1\\.5rem\\]{
  column-gap: 1.5rem;
}
.\\[word-spacing\\:0\\.25em\\]{
  word-spacing: 0.25em;
}

/* Base Body Styles */
body {
    margin: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* Prevent horizontal overflow on mobile */
    overflow-x: hidden;
}

code {
    font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* ========================
   CSS Custom Properties
   ======================== */

/* ========================
   Base Element Styles
   ======================== */

/* ========================
   Component Utilities
   ======================== */

/* ========================
   Utility Classes
   ======================== */

/* ========================
   Debug Wrapper (Existing)
   ======================== */

/* ========================
   Animation Utilities
   ======================== */

/* ========================
   Responsive Typography
   ======================== */

/* ========================
   Print Styles (for reports)
   ======================== */
@media print {

    /* Aggressively hide all non-report elements */
    .no-print,
    nav,
    aside,
    header,
    footer,
    .sidebar,
    .main-header,
    .control-buttons,
    button:not(.print-only),
    [data-radix-portal],
    .fixed.inset-0,
    .shadow-2xl,
    .shadow-xl,
    .bg-black\\/50,
    .bg-black\\/20 {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
    }

    html,
    body {
        height: auto !important;
        overflow: visible !important;
        background: white !important;
        color: black !important;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
        margin: 0 !important;
        padding: 0 !important;
    }

    .report-document {
        display: block !important;
        visibility: visible !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 10mm 0 !important;
        /* Add vertical safety padding */
        min-height: 297mm;
        box-shadow: none !important;
        border: none !important;
        position: relative !important;
        z-index: 9999 !important;
        background: white !important;
    }

    /* Secret technique for repeating margins on EVERY page */
    .report-page-header-spacer {
        height: 1.5cm;
    }

    .report-page-footer-spacer {
        height: 1cm;
    }

    table.report-print-container {
        width: 100%;
        border-collapse: collapse;
    }

    thead.report-header-spacer {
        display: table-header-group;
    }

    tfoot.report-footer-spacer {
        display: table-footer-group;
    }

    /* Professional report layout - setting margin to 0 hides browser headers/footers */
    @page {
        margin: 0;
        size: A4 portrait;
    }

    /* Force background colors for specific blocks */
    .bg-slate-50,
    .bg-white,
    .bg-blue-600,
    .bg-\\[\\#071633\\] {
        print-color-adjust: exact !important;
    }
}
.placeholder\\:text-amber-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-indigo-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground\\/40::placeholder{
  color: hsl(var(--muted-foreground) / 0.4);
}
.placeholder\\:text-muted-foreground\\/50::placeholder{
  color: hsl(var(--muted-foreground) / 0.5);
}
.placeholder\\:text-muted-foreground\\/60::placeholder{
  color: hsl(var(--muted-foreground) / 0.6);
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:bottom-0::before{
  content: var(--tw-content);
  bottom: 0px;
}
.before\\:bottom-2::before{
  content: var(--tw-content);
  bottom: 0.5rem;
}
.before\\:bottom-4::before{
  content: var(--tw-content);
  bottom: 1rem;
}
.before\\:left-0::before{
  content: var(--tw-content);
  left: 0px;
}
.before\\:left-3::before{
  content: var(--tw-content);
  left: 0.75rem;
}
.before\\:left-6::before{
  content: var(--tw-content);
  left: 1.5rem;
}
.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}
.before\\:top-2::before{
  content: var(--tw-content);
  top: 0.5rem;
}
.before\\:top-4::before{
  content: var(--tw-content);
  top: 1rem;
}
.before\\:w-0\\.5::before{
  content: var(--tw-content);
  width: 0.125rem;
}
.before\\:w-1::before{
  content: var(--tw-content);
  width: 0.25rem;
}
.before\\:bg-amber-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.before\\:bg-emerald-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.before\\:bg-rose-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.before\\:bg-slate-100::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.before\\:bg-slate-200::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.before\\:bg-slate-300::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.before\\:bg-slate-400::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child{
  border-right-width: 0px;
}
.last\\:pb-0:last-child{
  padding-bottom: 0px;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-yellow-400:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-amber-300:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-yellow-500\\/30:focus-within{
  --tw-ring-color: rgb(234 179 8 / 0.3);
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-px:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-amber-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500\\/40:hover{
  border-color: rgb(59 130 246 / 0.4);
}
.hover\\:border-blue-500\\/50:hover{
  border-color: rgb(59 130 246 / 0.5);
}
.hover\\:border-blue-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.hover\\:border-border:hover{
  border-color: hsl(var(--border));
}
.hover\\:border-border\\/80:hover{
  border-color: hsl(var(--border) / 0.8);
}
.hover\\:border-emerald-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-500\\/40:hover{
  border-color: rgb(16 185 129 / 0.4);
}
.hover\\:border-emerald-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.hover\\:border-pink-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary\\/20:hover{
  border-color: hsl(var(--primary) / 0.2);
}
.hover\\:border-primary\\/30:hover{
  border-color: hsl(var(--primary) / 0.3);
}
.hover\\:border-primary\\/40:hover{
  border-color: hsl(var(--primary) / 0.4);
}
.hover\\:border-primary\\/50:hover{
  border-color: hsl(var(--primary) / 0.5);
}
.hover\\:border-purple-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-500\\/50:hover{
  border-color: rgb(239 68 68 / 0.5);
}
.hover\\:border-rose-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.hover\\:border-sky-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300\\/80:hover{
  border-color: rgb(203 213 225 / 0.8);
}
.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:border-teal-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-500\\/20:hover{
  border-color: rgb(139 92 246 / 0.2);
}
.hover\\:border-violet-500\\/30:hover{
  border-color: rgb(139 92 246 / 0.3);
}
.hover\\:border-yellow-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.hover\\:border-yellow-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.hover\\:border-yellow-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.hover\\:border-l-blue-500:hover{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#00ba7c\\]\\/10:hover{
  background-color: rgb(0 186 124 / 0.1);
}
.hover\\:bg-\\[\\#1565C0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 101 192 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1d4ed8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1d9bf0\\]\\/10:hover{
  background-color: rgb(29 155 240 / 0.1);
}
.hover\\:bg-\\[\\#2AABEE\\]\\/\\[0\\.03\\]:hover{
  background-color: rgb(42 171 238 / 0.03);
}
.hover\\:bg-\\[\\#2AABEE\\]\\/\\[0\\.04\\]:hover{
  background-color: rgb(42 171 238 / 0.04);
}
.hover\\:bg-\\[\\#CC0000\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(204 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f0f2f5\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f91880\\]\\/10:hover{
  background-color: rgb(249 24 128 / 0.1);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-accent\\/10:hover{
  background-color: hsl(var(--accent) / 0.1);
}
.hover\\:bg-accent\\/30:hover{
  background-color: hsl(var(--accent) / 0.3);
}
.hover\\:bg-accent\\/50:hover{
  background-color: hsl(var(--accent) / 0.5);
}
.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50\\/20:hover{
  background-color: rgb(255 251 235 / 0.2);
}
.hover\\:bg-amber-50\\/30:hover{
  background-color: rgb(255 251 235 / 0.3);
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-background\\/20:hover{
  background-color: hsl(var(--background) / 0.2);
}
.hover\\:bg-black\\/40:hover{
  background-color: rgb(0 0 0 / 0.4);
}
.hover\\:bg-black\\/5:hover{
  background-color: rgb(0 0 0 / 0.05);
}
.hover\\:bg-black\\/50:hover{
  background-color: rgb(0 0 0 / 0.5);
}
.hover\\:bg-black\\/70:hover{
  background-color: rgb(0 0 0 / 0.7);
}
.hover\\:bg-black\\/80:hover{
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-300\\/60:hover{
  background-color: rgb(147 197 253 / 0.6);
}
.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50\\/20:hover{
  background-color: rgb(239 246 255 / 0.2);
}
.hover\\:bg-blue-50\\/40:hover{
  background-color: rgb(239 246 255 / 0.4);
}
.hover\\:bg-blue-50\\/50:hover{
  background-color: rgb(239 246 255 / 0.5);
}
.hover\\:bg-blue-50\\/70:hover{
  background-color: rgb(239 246 255 / 0.7);
}
.hover\\:bg-blue-500\\/20:hover{
  background-color: rgb(59 130 246 / 0.2);
}
.hover\\:bg-blue-500\\/5:hover{
  background-color: rgb(59 130 246 / 0.05);
}
.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-300\\/60:hover{
  background-color: rgb(103 232 249 / 0.6);
}
.hover\\:bg-destructive\\/10:hover{
  background-color: hsl(var(--destructive) / 0.1);
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-300\\/60:hover{
  background-color: rgb(110 231 183 / 0.6);
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50\\/20:hover{
  background-color: rgb(236 253 245 / 0.2);
}
.hover\\:bg-emerald-50\\/70:hover{
  background-color: rgb(236 253 245 / 0.7);
}
.hover\\:bg-emerald-500\\/\\[0\\.03\\]:hover{
  background-color: rgb(16 185 129 / 0.03);
}
.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-foreground\\/90:hover{
  background-color: hsl(var(--foreground) / 0.9);
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50\\/50:hover{
  background-color: rgb(249 250 251 / 0.5);
}
.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-500\\/10:hover{
  background-color: rgb(99 102 241 / 0.1);
}
.hover\\:bg-indigo-500\\/5:hover{
  background-color: rgb(99 102 241 / 0.05);
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/30:hover{
  background-color: hsl(var(--muted) / 0.3);
}
.hover\\:bg-muted\\/40:hover{
  background-color: hsl(var(--muted) / 0.4);
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-muted\\/60:hover{
  background-color: hsl(var(--muted) / 0.6);
}
.hover\\:bg-muted\\/70:hover{
  background-color: hsl(var(--muted) / 0.7);
}
.hover\\:bg-muted\\/80:hover{
  background-color: hsl(var(--muted) / 0.8);
}
.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-300\\/60:hover{
  background-color: rgb(249 168 212 / 0.6);
}
.hover\\:bg-pink-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-50\\/20:hover{
  background-color: rgb(253 242 248 / 0.2);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/15:hover{
  background-color: hsl(var(--primary) / 0.15);
}
.hover\\:bg-primary\\/5:hover{
  background-color: hsl(var(--primary) / 0.05);
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-50\\/50:hover{
  background-color: rgb(250 245 255 / 0.5);
}
.hover\\:bg-purple-50\\/60:hover{
  background-color: rgb(250 245 255 / 0.6);
}
.hover\\:bg-purple-500\\/5:hover{
  background-color: rgb(168 85 247 / 0.05);
}
.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-300\\/60:hover{
  background-color: rgb(252 165 165 / 0.6);
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50\\/50:hover{
  background-color: rgb(254 242 242 / 0.5);
}
.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(239 68 68 / 0.1);
}
.hover\\:bg-red-500\\/20:hover{
  background-color: rgb(239 68 68 / 0.2);
}
.hover\\:bg-red-500\\/80:hover{
  background-color: rgb(239 68 68 / 0.8);
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-500\\/5:hover{
  background-color: rgb(244 63 94 / 0.05);
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/10:hover{
  background-color: hsl(var(--secondary) / 0.1);
}
.hover\\:bg-secondary\\/5:hover{
  background-color: hsl(var(--secondary) / 0.05);
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-sky-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-500\\/10:hover{
  background-color: rgb(14 165 233 / 0.1);
}
.hover\\:bg-sky-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100\\/70:hover{
  background-color: rgb(241 245 249 / 0.7);
}
.hover\\:bg-slate-100\\/80:hover{
  background-color: rgb(241 245 249 / 0.8);
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200\\/50:hover{
  background-color: rgb(226 232 240 / 0.5);
}
.hover\\:bg-slate-200\\/60:hover{
  background-color: rgb(226 232 240 / 0.6);
}
.hover\\:bg-slate-300\\/70:hover{
  background-color: rgb(203 213 225 / 0.7);
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/50:hover{
  background-color: rgb(248 250 252 / 0.5);
}
.hover\\:bg-slate-50\\/60:hover{
  background-color: rgb(248 250 252 / 0.6);
}
.hover\\:bg-slate-50\\/80:hover{
  background-color: rgb(248 250 252 / 0.8);
}
.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-transparent:hover{
  background-color: transparent;
}
.hover\\:bg-violet-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-50\\/30:hover{
  background-color: rgb(245 243 255 / 0.3);
}
.hover\\:bg-violet-500\\/10:hover{
  background-color: rgb(139 92 246 / 0.1);
}
.hover\\:bg-violet-500\\/20:hover{
  background-color: rgb(139 92 246 / 0.2);
}
.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}
.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/50:hover{
  background-color: rgb(255 255 255 / 0.5);
}
.hover\\:bg-white\\/60:hover{
  background-color: rgb(255 255 255 / 0.6);
}
.hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}
.hover\\:bg-white\\/\\[0\\.05\\]:hover{
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-yellow-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1));
}
.hover\\:from-emerald-700:hover{
  --tw-gradient-from: #047857 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-indigo-500:hover{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-indigo-700:hover{
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-purple-600:hover{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-red-800:hover{
  --tw-gradient-from: #991b1b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(153 27 27 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-sky-700:hover{
  --tw-gradient-from: #0369a1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 105 161 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-slate-400:hover{
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-violet-700:hover{
  --tw-gradient-from: #6d28d9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 40 217 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-emerald-800:hover{
  --tw-gradient-to: #065f46 var(--tw-gradient-to-position);
}
.hover\\:to-indigo-700:hover{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.hover\\:to-pink-600:hover{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.hover\\:to-purple-700:hover{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.hover\\:to-red-700:hover{
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}
.hover\\:to-sky-800:hover{
  --tw-gradient-to: #075985 var(--tw-gradient-to-position);
}
.hover\\:to-teal-700:hover{
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}
.hover\\:to-violet-500:hover{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.hover\\:text-\\[\\#2AABEE\\]\\/70:hover{
  color: rgb(42 171 238 / 0.7);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-700:hover{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-800:hover{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600\\/80:hover{
  color: rgb(37 99 235 / 0.8);
}
.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-destructive:hover{
  color: hsl(var(--destructive));
}
.hover\\:text-destructive\\/80:hover{
  color: hsl(var(--destructive) / 0.8);
}
.hover\\:text-emerald-500:hover{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-gray-300:hover{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-900:hover{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-orange-400:hover{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-700:hover{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-600:hover{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary:hover{
  color: hsl(var(--primary));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-primary\\/80:hover{
  color: hsl(var(--primary) / 0.8);
}
.hover\\:text-purple-600:hover{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-600\\/80:hover{
  color: rgb(147 51 234 / 0.8);
}
.hover\\:text-purple-800:hover{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-200:hover{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-600:hover{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-700:hover{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-400:hover{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-500:hover{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-200:hover{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-600:hover{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-700:hover{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-800:hover{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-white\\/80:hover{
  color: rgb(255 255 255 / 0.8);
}
.hover\\:text-yellow-700:hover{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-800:hover{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-900:hover{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-60:hover{
  opacity: 0.6;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-85:hover{
  opacity: 0.85;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:opacity-95:hover{
  opacity: 0.95;
}
.hover\\:shadow:hover{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_2px_8px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]:hover{
  --tw-shadow: 0 2px 8px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_4px_16px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]:hover{
  --tw-shadow: 0 4px 16px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-red-700\\/40:hover{
  --tw-shadow-color: rgb(185 28 28 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-2:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-blue-500:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-indigo-400:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-purple-500:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.hover\\:brightness-105:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-110:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:drop-shadow-md:hover{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-\\[\\#2AABEE\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(42 171 238 / var(--tw-border-opacity, 1));
}
.focus\\:border-amber-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.focus\\:border-amber-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.focus\\:border-green-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-primary:focus{
  border-color: hsl(var(--primary));
}
.focus\\:border-purple-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.focus\\:border-rose-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-500\\/50:focus{
  border-color: rgb(14 165 233 / 0.5);
}
.focus\\:border-slate-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.focus\\:border-teal-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus{
  border-color: transparent;
}
.focus\\:border-violet-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.focus\\:border-violet-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.focus\\:border-violet-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-violet-500\\/50:focus{
  border-color: rgb(139 92 246 / 0.5);
}
.focus\\:border-white\\/30:focus{
  border-color: rgb(255 255 255 / 0.3);
}
.focus\\:border-white\\/80:focus{
  border-color: rgb(255 255 255 / 0.8);
}
.focus\\:border-yellow-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-card:focus{
  background-color: hsl(var(--card));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:bg-slate-50\\/50:focus{
  background-color: rgb(248 250 252 / 0.5);
}
.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-white\\/10:focus{
  background-color: rgb(255 255 255 / 0.1);
}
.focus\\:bg-white\\/25:focus{
  background-color: rgb(255 255 255 / 0.25);
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#2AABEE\\]\\/10:focus{
  --tw-ring-color: rgb(42 171 238 / 0.1);
}
.focus\\:ring-amber-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-amber-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-amber-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-amber-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500\\/20:focus{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.focus\\:ring-emerald-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
.focus\\:ring-orange-500\\/40:focus{
  --tw-ring-color: rgb(249 115 22 / 0.4);
}
.focus\\:ring-primary:focus{
  --tw-ring-color: hsl(var(--primary));
}
.focus\\:ring-primary\\/20:focus{
  --tw-ring-color: hsl(var(--primary) / 0.2);
}
.focus\\:ring-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500\\/30:focus{
  --tw-ring-color: rgb(239 68 68 / 0.3);
}
.focus\\:ring-red-600\\/20:focus{
  --tw-ring-color: rgb(220 38 38 / 0.2);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-rose-500\\/20:focus{
  --tw-ring-color: rgb(244 63 94 / 0.2);
}
.focus\\:ring-sky-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(125 211 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-500\\/40:focus{
  --tw-ring-color: rgb(14 165 233 / 0.4);
}
.focus\\:ring-teal-500\\/20:focus{
  --tw-ring-color: rgb(20 184 166 / 0.2);
}
.focus\\:ring-violet-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(237 233 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-violet-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-violet-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-violet-400\\/30:focus{
  --tw-ring-color: rgb(167 139 250 / 0.3);
}
.focus\\:ring-violet-500\\/20:focus{
  --tw-ring-color: rgb(139 92 246 / 0.2);
}
.focus\\:ring-violet-500\\/30:focus{
  --tw-ring-color: rgb(139 92 246 / 0.3);
}
.focus\\:ring-violet-500\\/50:focus{
  --tw-ring-color: rgb(139 92 246 / 0.5);
}
.focus\\:ring-white\\/50:focus{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.focus\\:ring-yellow-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 204 21 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:stroke-yellow-500:focus-visible{
  stroke: #eab308;
}
.focus-visible\\:text-slate-500:focus-visible{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.focus-visible\\:text-yellow-800:focus-visible{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-amber-400\\/40:focus-visible{
  --tw-ring-color: rgb(251 191 36 / 0.4);
}
.focus-visible\\:ring-emerald-400:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-emerald-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-gray-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-purple-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-slate-400:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(148 163 184 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:translate-y-\\[1px\\]:active{
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-90:active{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.active\\:bg-sky-800:active{
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity, 1));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-blue-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-indigo-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-white:disabled{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.group:focus-within .group-focus-within\\:text-green-500\\/50{
  color: rgb(34 197 94 / 0.5);
}
.group\\/tip:focus-within .group-focus-within\\/tip\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:line-clamp-none{
  overflow: visible;
  display: block;
  -webkit-box-orient: horizontal;
  -webkit-line-clamp: none;
}
.group\\/row:hover .group-hover\\/row\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-\\[100\\%\\]{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-x-100{
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-red-700{
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#ccd6dd\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(204 214 221 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.group\\/row:hover .group-hover\\/row\\:text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.group\\/title:hover .group-hover\\/title\\:text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#00ba7c\\]{
  --tw-text-opacity: 1;
  color: rgb(0 186 124 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#1d9bf0\\]{
  --tw-text-opacity: 1;
  color: rgb(29 155 240 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#f91880\\]{
  --tw-text-opacity: 1;
  color: rgb(249 24 128 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-foreground{
  color: hsl(var(--foreground));
}
.group:hover .group-hover\\:text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-primary{
  color: hsl(var(--primary));
}
.group:hover .group-hover\\:text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.group:hover .group-hover\\:text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.group\\/item:hover .group-hover\\/item\\:opacity-100{
  opacity: 1;
}
.group\\/media:hover .group-hover\\/media\\:opacity-100{
  opacity: 1;
}
.group\\/row:hover .group-hover\\/row\\:opacity-100{
  opacity: 1;
}
.group\\/tip:hover .group-hover\\/tip\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[state\\=active\\]\\:border-b-2[data-state="active"]{
  border-bottom-width: 2px;
}
.data-\\[state\\=active\\]\\:border-primary[data-state="active"]{
  border-color: hsl(var(--primary));
}
.data-\\[state\\=checked\\]\\:border-purple-600[data-state="checked"]{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=active\\]\\:bg-primary[data-state="active"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=active\\]\\:bg-primary\\/10[data-state="active"]{
  background-color: hsl(var(--primary) / 0.1);
}
.data-\\[state\\=active\\]\\:bg-transparent[data-state="active"]{
  background-color: transparent;
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=checked\\]\\:bg-purple-600[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[state\\=active\\]\\:font-semibold[data-state="active"]{
  font-weight: 600;
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=active\\]\\:text-primary[data-state="active"]{
  color: hsl(var(--primary));
}
.data-\\[state\\=active\\]\\:text-primary-foreground[data-state="active"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-md[data-state="active"]{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-none[data-state="active"]{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@supports (backdrop-filter: var(--tw)){

  .supports-\\[backdrop-filter\\]\\:bg-background\\/60{
    background-color: hsl(var(--background) / 0.6);
  }
}
.dark\\:hidden:is(.dark *){
  display: none;
}
.dark\\:divide-gray-800\\/50:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(31 41 55 / 0.5);
}
.dark\\:divide-slate-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-divide-opacity, 1));
}
.dark\\:border-\\[\\#0f0f0f\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(15 15 15 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-800\\/30:is(.dark *){
  border-color: rgb(146 64 14 / 0.3);
}
.dark\\:border-amber-900\\/40:is(.dark *){
  border-color: rgb(120 53 15 / 0.4);
}
.dark\\:border-amber-900\\/50:is(.dark *){
  border-color: rgb(120 53 15 / 0.5);
}
.dark\\:border-blue-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-800\\/30:is(.dark *){
  border-color: rgb(30 64 175 / 0.3);
}
.dark\\:border-blue-800\\/40:is(.dark *){
  border-color: rgb(30 64 175 / 0.4);
}
.dark\\:border-blue-800\\/50:is(.dark *){
  border-color: rgb(30 64 175 / 0.5);
}
.dark\\:border-blue-900\\/50:is(.dark *){
  border-color: rgb(30 58 138 / 0.5);
}
.dark\\:border-cyan-800\\/30:is(.dark *){
  border-color: rgb(21 94 117 / 0.3);
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
.dark\\:border-emerald-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.dark\\:border-emerald-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}
.dark\\:border-emerald-800\\/30:is(.dark *){
  border-color: rgb(6 95 70 / 0.3);
}
.dark\\:border-emerald-800\\/40:is(.dark *){
  border-color: rgb(6 95 70 / 0.4);
}
.dark\\:border-emerald-800\\/50:is(.dark *){
  border-color: rgb(6 95 70 / 0.5);
}
.dark\\:border-emerald-900\\/50:is(.dark *){
  border-color: rgb(6 78 59 / 0.5);
}
.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-800\\/30:is(.dark *){
  border-color: rgb(22 101 52 / 0.3);
}
.dark\\:border-green-900\\/40:is(.dark *){
  border-color: rgb(20 83 45 / 0.4);
}
.dark\\:border-indigo-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.dark\\:border-indigo-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}
.dark\\:border-indigo-800\\/30:is(.dark *){
  border-color: rgb(55 48 163 / 0.3);
}
.dark\\:border-indigo-900\\/30:is(.dark *){
  border-color: rgb(49 46 129 / 0.3);
}
.dark\\:border-indigo-900\\/40:is(.dark *){
  border-color: rgb(49 46 129 / 0.4);
}
.dark\\:border-lime-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity, 1));
}
.dark\\:border-lime-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / var(--tw-border-opacity, 1));
}
.dark\\:border-orange-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.dark\\:border-orange-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity, 1));
}
.dark\\:border-orange-800\\/30:is(.dark *){
  border-color: rgb(154 52 18 / 0.3);
}
.dark\\:border-pink-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.dark\\:border-pink-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity, 1));
}
.dark\\:border-pink-800\\/30:is(.dark *){
  border-color: rgb(157 23 77 / 0.3);
}
.dark\\:border-purple-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.dark\\:border-purple-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}
.dark\\:border-purple-800\\/30:is(.dark *){
  border-color: rgb(107 33 168 / 0.3);
}
.dark\\:border-purple-900\\/50:is(.dark *){
  border-color: rgb(88 28 135 / 0.5);
}
.dark\\:border-red-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-800\\/30:is(.dark *){
  border-color: rgb(153 27 27 / 0.3);
}
.dark\\:border-red-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-900\\/30:is(.dark *){
  border-color: rgb(127 29 29 / 0.3);
}
.dark\\:border-red-900\\/40:is(.dark *){
  border-color: rgb(127 29 29 / 0.4);
}
.dark\\:border-rose-800\\/30:is(.dark *){
  border-color: rgb(159 18 57 / 0.3);
}
.dark\\:border-sky-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700\\/50:is(.dark *){
  border-color: rgb(51 65 85 / 0.5);
}
.dark\\:border-slate-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.dark\\:border-teal-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.dark\\:border-teal-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity, 1));
}
.dark\\:border-teal-800\\/30:is(.dark *){
  border-color: rgb(17 94 89 / 0.3);
}
.dark\\:border-teal-900\\/40:is(.dark *){
  border-color: rgb(19 78 74 / 0.4);
}
.dark\\:border-violet-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity, 1));
}
.dark\\:border-violet-800\\/30:is(.dark *){
  border-color: rgb(91 33 182 / 0.3);
}
.dark\\:border-violet-900\\/50:is(.dark *){
  border-color: rgb(76 29 149 / 0.5);
}
.dark\\:border-white:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-700\\/50:is(.dark *){
  border-color: rgb(161 98 7 / 0.5);
}
.dark\\:border-yellow-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity, 1));
}
.dark\\:border-zinc-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.dark\\:bg-\\[\\#0d1117\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(13 17 23 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#0f0f0f\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 15 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1a1a1a\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-900\\/10:is(.dark *){
  background-color: rgb(120 53 15 / 0.1);
}
.dark\\:bg-amber-900\\/20:is(.dark *){
  background-color: rgb(120 53 15 / 0.2);
}
.dark\\:bg-amber-900\\/25:is(.dark *){
  background-color: rgb(120 53 15 / 0.25);
}
.dark\\:bg-amber-900\\/30:is(.dark *){
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:bg-amber-900\\/60:is(.dark *){
  background-color: rgb(120 53 15 / 0.6);
}
.dark\\:bg-amber-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-950\\/10:is(.dark *){
  background-color: rgb(69 26 3 / 0.1);
}
.dark\\:bg-amber-950\\/20:is(.dark *){
  background-color: rgb(69 26 3 / 0.2);
}
.dark\\:bg-amber-950\\/30:is(.dark *){
  background-color: rgb(69 26 3 / 0.3);
}
.dark\\:bg-amber-950\\/40:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}
.dark\\:bg-black:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-black\\/20:is(.dark *){
  background-color: rgb(0 0 0 / 0.2);
}
.dark\\:bg-black\\/80:is(.dark *){
  background-color: rgb(0 0 0 / 0.8);
}
.dark\\:bg-blue-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900\\/20:is(.dark *){
  background-color: rgb(30 58 138 / 0.2);
}
.dark\\:bg-blue-900\\/30:is(.dark *){
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:bg-blue-900\\/50:is(.dark *){
  background-color: rgb(30 58 138 / 0.5);
}
.dark\\:bg-blue-900\\/60:is(.dark *){
  background-color: rgb(30 58 138 / 0.6);
}
.dark\\:bg-blue-950\\/20:is(.dark *){
  background-color: rgb(23 37 84 / 0.2);
}
.dark\\:bg-blue-950\\/30:is(.dark *){
  background-color: rgb(23 37 84 / 0.3);
}
.dark\\:bg-blue-950\\/40:is(.dark *){
  background-color: rgb(23 37 84 / 0.4);
}
.dark\\:bg-cyan-950\\/20:is(.dark *){
  background-color: rgb(8 51 68 / 0.2);
}
.dark\\:bg-emerald-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-900\\/20:is(.dark *){
  background-color: rgb(6 78 59 / 0.2);
}
.dark\\:bg-emerald-900\\/30:is(.dark *){
  background-color: rgb(6 78 59 / 0.3);
}
.dark\\:bg-emerald-900\\/60:is(.dark *){
  background-color: rgb(6 78 59 / 0.6);
}
.dark\\:bg-emerald-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-950\\/20:is(.dark *){
  background-color: rgb(2 44 34 / 0.2);
}
.dark\\:bg-emerald-950\\/30:is(.dark *){
  background-color: rgb(2 44 34 / 0.3);
}
.dark\\:bg-emerald-950\\/40:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}
.dark\\:bg-emerald-950\\/50:is(.dark *){
  background-color: rgb(2 44 34 / 0.5);
}
.dark\\:bg-gray-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800\\/50:is(.dark *){
  background-color: rgb(31 41 55 / 0.5);
}
.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-900\\/20:is(.dark *){
  background-color: rgb(17 24 39 / 0.2);
}
.dark\\:bg-gray-900\\/50:is(.dark *){
  background-color: rgb(17 24 39 / 0.5);
}
.dark\\:bg-green-900\\/20:is(.dark *){
  background-color: rgb(20 83 45 / 0.2);
}
.dark\\:bg-green-900\\/30:is(.dark *){
  background-color: rgb(20 83 45 / 0.3);
}
.dark\\:bg-green-950\\/20:is(.dark *){
  background-color: rgb(5 46 22 / 0.2);
}
.dark\\:bg-green-950\\/30:is(.dark *){
  background-color: rgb(5 46 22 / 0.3);
}
.dark\\:bg-indigo-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-900\\/10:is(.dark *){
  background-color: rgb(49 46 129 / 0.1);
}
.dark\\:bg-indigo-900\\/40:is(.dark *){
  background-color: rgb(49 46 129 / 0.4);
}
.dark\\:bg-indigo-950\\/20:is(.dark *){
  background-color: rgb(30 27 75 / 0.2);
}
.dark\\:bg-indigo-950\\/30:is(.dark *){
  background-color: rgb(30 27 75 / 0.3);
}
.dark\\:bg-indigo-950\\/40:is(.dark *){
  background-color: rgb(30 27 75 / 0.4);
}
.dark\\:bg-lime-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-lime-950\\/30:is(.dark *){
  background-color: rgb(26 46 5 / 0.3);
}
.dark\\:bg-lime-950\\/40:is(.dark *){
  background-color: rgb(26 46 5 / 0.4);
}
.dark\\:bg-orange-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-orange-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-orange-900\\/30:is(.dark *){
  background-color: rgb(124 45 18 / 0.3);
}
.dark\\:bg-orange-900\\/35:is(.dark *){
  background-color: rgb(124 45 18 / 0.35);
}
.dark\\:bg-orange-950\\/20:is(.dark *){
  background-color: rgb(67 20 7 / 0.2);
}
.dark\\:bg-orange-950\\/30:is(.dark *){
  background-color: rgb(67 20 7 / 0.3);
}
.dark\\:bg-orange-950\\/40:is(.dark *){
  background-color: rgb(67 20 7 / 0.4);
}
.dark\\:bg-pink-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-pink-900\\/30:is(.dark *){
  background-color: rgb(131 24 67 / 0.3);
}
.dark\\:bg-pink-950\\/20:is(.dark *){
  background-color: rgb(80 7 36 / 0.2);
}
.dark\\:bg-pink-950\\/30:is(.dark *){
  background-color: rgb(80 7 36 / 0.3);
}
.dark\\:bg-pink-950\\/40:is(.dark *){
  background-color: rgb(80 7 36 / 0.4);
}
.dark\\:bg-purple-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-900\\/30:is(.dark *){
  background-color: rgb(88 28 135 / 0.3);
}
.dark\\:bg-purple-950\\/20:is(.dark *){
  background-color: rgb(59 7 100 / 0.2);
}
.dark\\:bg-purple-950\\/30:is(.dark *){
  background-color: rgb(59 7 100 / 0.3);
}
.dark\\:bg-purple-950\\/40:is(.dark *){
  background-color: rgb(59 7 100 / 0.4);
}
.dark\\:bg-red-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-900\\/10:is(.dark *){
  background-color: rgb(127 29 29 / 0.1);
}
.dark\\:bg-red-900\\/20:is(.dark *){
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:bg-red-900\\/30:is(.dark *){
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:bg-red-900\\/40:is(.dark *){
  background-color: rgb(127 29 29 / 0.4);
}
.dark\\:bg-red-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-950\\/20:is(.dark *){
  background-color: rgb(69 10 10 / 0.2);
}
.dark\\:bg-red-950\\/30:is(.dark *){
  background-color: rgb(69 10 10 / 0.3);
}
.dark\\:bg-red-950\\/40:is(.dark *){
  background-color: rgb(69 10 10 / 0.4);
}
.dark\\:bg-red-950\\/5:is(.dark *){
  background-color: rgb(69 10 10 / 0.05);
}
.dark\\:bg-red-950\\/50:is(.dark *){
  background-color: rgb(69 10 10 / 0.5);
}
.dark\\:bg-rose-950\\/20:is(.dark *){
  background-color: rgb(76 5 25 / 0.2);
}
.dark\\:bg-rose-950\\/30:is(.dark *){
  background-color: rgb(76 5 25 / 0.3);
}
.dark\\:bg-sky-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-sky-950\\/30:is(.dark *){
  background-color: rgb(8 47 73 / 0.3);
}
.dark\\:bg-slate-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800\\/20:is(.dark *){
  background-color: rgb(30 41 59 / 0.2);
}
.dark\\:bg-slate-800\\/30:is(.dark *){
  background-color: rgb(30 41 59 / 0.3);
}
.dark\\:bg-slate-800\\/40:is(.dark *){
  background-color: rgb(30 41 59 / 0.4);
}
.dark\\:bg-slate-800\\/50:is(.dark *){
  background-color: rgb(30 41 59 / 0.5);
}
.dark\\:bg-slate-800\\/60:is(.dark *){
  background-color: rgb(30 41 59 / 0.6);
}
.dark\\:bg-slate-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-900\\/10:is(.dark *){
  background-color: rgb(15 23 42 / 0.1);
}
.dark\\:bg-slate-900\\/30:is(.dark *){
  background-color: rgb(15 23 42 / 0.3);
}
.dark\\:bg-slate-900\\/40:is(.dark *){
  background-color: rgb(15 23 42 / 0.4);
}
.dark\\:bg-slate-900\\/50:is(.dark *){
  background-color: rgb(15 23 42 / 0.5);
}
.dark\\:bg-slate-900\\/90:is(.dark *){
  background-color: rgb(15 23 42 / 0.9);
}
.dark\\:bg-slate-900\\/95:is(.dark *){
  background-color: rgb(15 23 42 / 0.95);
}
.dark\\:bg-slate-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-950\\/20:is(.dark *){
  background-color: rgb(2 6 23 / 0.2);
}
.dark\\:bg-slate-950\\/50:is(.dark *){
  background-color: rgb(2 6 23 / 0.5);
}
.dark\\:bg-teal-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-teal-900\\/10:is(.dark *){
  background-color: rgb(19 78 74 / 0.1);
}
.dark\\:bg-teal-950\\/20:is(.dark *){
  background-color: rgb(4 47 46 / 0.2);
}
.dark\\:bg-teal-950\\/30:is(.dark *){
  background-color: rgb(4 47 46 / 0.3);
}
.dark\\:bg-teal-950\\/40:is(.dark *){
  background-color: rgb(4 47 46 / 0.4);
}
.dark\\:bg-violet-900\\/60:is(.dark *){
  background-color: rgb(76 29 149 / 0.6);
}
.dark\\:bg-violet-950\\/20:is(.dark *){
  background-color: rgb(46 16 101 / 0.2);
}
.dark\\:bg-violet-950\\/30:is(.dark *){
  background-color: rgb(46 16 101 / 0.3);
}
.dark\\:bg-violet-950\\/40:is(.dark *){
  background-color: rgb(46 16 101 / 0.4);
}
.dark\\:bg-white:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-yellow-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-yellow-800\\/30:is(.dark *){
  background-color: rgb(133 77 14 / 0.3);
}
.dark\\:bg-yellow-950\\/10:is(.dark *){
  background-color: rgb(66 32 6 / 0.1);
}
.dark\\:bg-yellow-950\\/30:is(.dark *){
  background-color: rgb(66 32 6 / 0.3);
}
.dark\\:bg-yellow-950\\/40:is(.dark *){
  background-color: rgb(66 32 6 / 0.4);
}
.dark\\:bg-zinc-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-900\\/50:is(.dark *){
  background-color: rgb(24 24 27 / 0.5);
}
.dark\\:from-blue-900\\/30:is(.dark *){
  --tw-gradient-from: rgb(30 58 138 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-slate-600:is(.dark *){
  --tw-gradient-from: #475569 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-slate-800:is(.dark *){
  --tw-gradient-from: #1e293b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 41 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-slate-900:is(.dark *){
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:to-indigo-900\\/20:is(.dark *){
  --tw-gradient-to: rgb(49 46 129 / 0.2) var(--tw-gradient-to-position);
}
.dark\\:to-slate-900:is(.dark *){
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.dark\\:to-slate-900\\/50:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0.5) var(--tw-gradient-to-position);
}
.dark\\:to-slate-950:is(.dark *){
  --tw-gradient-to: #020617 var(--tw-gradient-to-position);
}
.dark\\:fill-red-400:is(.dark *){
  fill: #f87171;
}
.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400\\/60:is(.dark *){
  color: rgb(251 191 36 / 0.6);
}
.dark\\:text-amber-400\\/70:is(.dark *){
  color: rgb(251 191 36 / 0.7);
}
.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400\\/60:is(.dark *){
  color: rgb(96 165 250 / 0.6);
}
.dark\\:text-cyan-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400\\/60:is(.dark *){
  color: rgb(52 211 153 / 0.6);
}
.dark\\:text-emerald-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.dark\\:text-lime-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / var(--tw-text-opacity, 1));
}
.dark\\:text-lime-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / var(--tw-text-opacity, 1));
}
.dark\\:text-orange-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.dark\\:text-orange-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.dark\\:text-violet-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-violet-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-violet-400\\/60:is(.dark *){
  color: rgb(167 139 250 / 0.6);
}
.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.dark\\:text-zinc-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}
.dark\\:text-zinc-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.dark\\:shadow-blue-900\\/30:is(.dark *){
  --tw-shadow-color: rgb(30 58 138 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.dark\\:shadow-blue-900\\/40:is(.dark *){
  --tw-shadow-color: rgb(30 58 138 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.dark\\:ring-green-700:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 128 61 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-offset-slate-900:is(.dark *){
  --tw-ring-offset-color: #0f172a;
}
.dark\\:placeholder\\:text-gray-500:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:border-red-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-amber-950:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-950\\/20:hover:is(.dark *){
  background-color: rgb(23 37 84 / 0.2);
}
.dark\\:hover\\:bg-emerald-900\\/30:hover:is(.dark *){
  background-color: rgb(6 78 59 / 0.3);
}
.dark\\:hover\\:bg-emerald-950:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-emerald-950\\/30:hover:is(.dark *){
  background-color: rgb(2 44 34 / 0.3);
}
.dark\\:hover\\:bg-gray-200:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-800\\/30:hover:is(.dark *){
  background-color: rgb(31 41 55 / 0.3);
}
.dark\\:hover\\:bg-gray-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-900\\/30:hover:is(.dark *){
  background-color: rgb(17 24 39 / 0.3);
}
.dark\\:hover\\:bg-green-950\\/20:hover:is(.dark *){
  background-color: rgb(5 46 22 / 0.2);
}
.dark\\:hover\\:bg-red-950:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-950\\/30:hover:is(.dark *){
  background-color: rgb(69 10 10 / 0.3);
}
.dark\\:hover\\:bg-rose-950\\/20:hover:is(.dark *){
  background-color: rgb(76 5 25 / 0.2);
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-900\\/50:hover:is(.dark *){
  background-color: rgb(15 23 42 / 0.5);
}
.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:hover\\:from-slate-500:hover:is(.dark *){
  --tw-gradient-from: #64748b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:hover\\:text-blue-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-violet-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:bg-slate-900:focus:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:focus-visible\\:ring-gray-700:focus-visible:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-blue-900\\/20:is(.dark *){
  background-color: rgb(30 58 138 / 0.2);
}
.group:hover .dark\\:group-hover\\:bg-emerald-900\\/20:is(.dark *){
  background-color: rgb(6 78 59 / 0.2);
}
.group:hover .dark\\:group-hover\\:bg-pink-900\\/20:is(.dark *){
  background-color: rgb(131 24 67 / 0.2);
}
.group:hover .dark\\:group-hover\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
@media (min-width: 640px){

  .sm\\:inset-4{
    inset: 1rem;
  }

  .sm\\:inset-auto{
    inset: auto;
  }

  .sm\\:-left-\\[43px\\]{
    left: -43px;
  }

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:left-1\\/2{
    left: 50%;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-1\\/2{
    top: 50%;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-72{
    height: 18rem;
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:max-h-\\[80vh\\]{
    max-height: 80vh;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-72{
    width: 18rem;
  }

  .sm\\:w-\\[120px\\]{
    width: 120px;
  }

  .sm\\:w-\\[140px\\]{
    width: 140px;
  }

  .sm\\:w-\\[180px\\]{
    width: 180px;
  }

  .sm\\:w-\\[200px\\]{
    width: 200px;
  }

  .sm\\:w-\\[250px\\]{
    width: 250px;
  }

  .sm\\:w-\\[600px\\]{
    width: 600px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-2xl{
    max-width: 42rem;
  }

  .sm\\:max-w-5xl{
    max-width: 64rem;
  }

  .sm\\:max-w-\\[400px\\]{
    max-width: 400px;
  }

  .sm\\:max-w-\\[425px\\]{
    max-width: 425px;
  }

  .sm\\:max-w-\\[450px\\]{
    max-width: 450px;
  }

  .sm\\:max-w-\\[500px\\]{
    max-width: 500px;
  }

  .sm\\:max-w-\\[600px\\]{
    max-width: 600px;
  }

  .sm\\:max-w-\\[70\\%\\]{
    max-width: 70%;
  }

  .sm\\:max-w-\\[700px\\]{
    max-width: 700px;
  }

  .sm\\:max-w-fit{
    max-width: fit-content;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:flex-grow-0{
    flex-grow: 0;
  }

  .sm\\:-translate-x-1\\/2{
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:translate-y-4{
    --tw-translate-y: 1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:columns-2{
    columns: 2;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:bg-black\\/0{
    background-color: rgb(0 0 0 / 0);
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .sm\\:pl-10{
    padding-left: 2.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:opacity-0{
    opacity: 0;
  }

  .sm\\:before\\:left-5::before{
    content: var(--tw-content);
    left: 1.25rem;
  }

  .group:hover .sm\\:group-hover\\:translate-y-0{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .sm\\:group-hover\\:bg-black\\/20{
    background-color: rgb(0 0 0 / 0.2);
  }

  .group:hover .sm\\:group-hover\\:opacity-100{
    opacity: 1;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-2{
    margin-top: 0.5rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:aspect-auto{
    aspect-ratio: auto;
  }

  .md\\:h-7{
    height: 1.75rem;
  }

  .md\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-32{
    width: 8rem;
  }

  .md\\:w-7{
    width: 1.75rem;
  }

  .md\\:w-\\[240px\\]{
    width: 240px;
  }

  .md\\:w-\\[420px\\]{
    width: 420px;
  }

  .md\\:w-\\[480px\\]{
    width: 480px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:max-w-sm{
    max-width: 24rem;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:columns-2{
    columns: 2;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-16{
    gap: 4rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px){

  .lg\\:-inset-2{
    inset: -0.5rem;
  }

  .lg\\:top-20{
    top: 5rem;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-8{
    margin-bottom: 2rem;
  }

  .lg\\:mt-2{
    margin-top: 0.5rem;
  }

  .lg\\:mt-6{
    margin-top: 1.5rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-10{
    height: 2.5rem;
  }

  .lg\\:h-11{
    height: 2.75rem;
  }

  .lg\\:h-12{
    height: 3rem;
  }

  .lg\\:h-14{
    height: 3.5rem;
  }

  .lg\\:h-20{
    height: 5rem;
  }

  .lg\\:h-28{
    height: 7rem;
  }

  .lg\\:h-4{
    height: 1rem;
  }

  .lg\\:h-5{
    height: 1.25rem;
  }

  .lg\\:h-6{
    height: 1.5rem;
  }

  .lg\\:h-8{
    height: 2rem;
  }

  .lg\\:h-96{
    height: 24rem;
  }

  .lg\\:w-10{
    width: 2.5rem;
  }

  .lg\\:w-11{
    width: 2.75rem;
  }

  .lg\\:w-12{
    width: 3rem;
  }

  .lg\\:w-14{
    width: 3.5rem;
  }

  .lg\\:w-28{
    width: 7rem;
  }

  .lg\\:w-4{
    width: 1rem;
  }

  .lg\\:w-5{
    width: 1.25rem;
  }

  .lg\\:w-6{
    width: 1.5rem;
  }

  .lg\\:w-8{
    width: 2rem;
  }

  .lg\\:w-96{
    width: 24rem;
  }

  .lg\\:w-\\[260px\\]{
    width: 260px;
  }

  .lg\\:w-\\[420px\\]{
    width: 420px;
  }

  .lg\\:w-\\[45\\%\\]{
    width: 45%;
  }

  .lg\\:min-w-\\[320px\\]{
    min-width: 320px;
  }

  .lg\\:max-w-md{
    max-width: 28rem;
  }

  .lg\\:max-w-none{
    max-width: none;
  }

  .lg\\:columns-3{
    columns: 3;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[2\\.6fr_1\\.2fr_1\\.2fr_1fr_1fr\\]{
    grid-template-columns: 2.6fr 1.2fr 1.2fr 1fr 1fr;
  }

  .lg\\:grid-cols-\\[270px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 270px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[290px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 290px minmax(0,1fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-3{
    gap: 0.75rem;
  }

  .lg\\:gap-4{
    gap: 1rem;
  }

  .lg\\:gap-5{
    gap: 1.25rem;
  }

  .lg\\:space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .lg\\:border-4{
    border-width: 4px;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:p-2{
    padding: 0.5rem;
  }

  .lg\\:p-5{
    padding: 1.25rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:pb-4{
    padding-bottom: 1rem;
  }

  .lg\\:pl-6{
    padding-left: 1.5rem;
  }

  .lg\\:pl-\\[82px\\]{
    padding-left: 82px;
  }

  .lg\\:pt-0{
    padding-top: 0px;
  }

  .lg\\:pt-20{
    padding-top: 5rem;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .lg\\:blur-\\[150px\\]{
    --tw-blur: blur(150px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
}
@media (min-width: 1280px){

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .xl\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .xl\\:w-\\[280px\\]{
    width: 280px;
  }

  .xl\\:w-auto{
    width: auto;
  }

  .xl\\:min-w-0{
    min-width: 0px;
  }

  .xl\\:columns-2{
    columns: 2;
  }

  .xl\\:columns-3{
    columns: 3;
  }

  .xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[220px_minmax\\(0\\2c 1fr\\)_260px\\]{
    grid-template-columns: 220px minmax(0,1fr) 260px;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_320px\\]{
    grid-template-columns: minmax(0,1fr) 320px;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-end{
    justify-content: flex-end;
  }

  .xl\\:gap-4{
    gap: 1rem;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
}
@media print{

  .print\\:block{
    display: block;
  }

  .print\\:inline{
    display: inline;
  }

  .print\\:hidden{
    display: none;
  }

  .print\\:h-auto{
    height: auto;
  }

  .print\\:max-h-none{
    max-height: none;
  }

  .print\\:flex-wrap{
    flex-wrap: wrap;
  }

  .print\\:gap-0{
    gap: 0px;
  }

  .print\\:overflow-visible{
    overflow: visible;
  }

  .print\\:border-0{
    border-width: 0px;
  }

  .print\\:pl-0{
    padding-left: 0px;
  }

  .print\\:pt-0{
    padding-top: 0px;
  }

  .print\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>button\\]\\:hidden>button{
  display: none;
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;QAAA,yCAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,iBAAc;QAAd,0BAAc;QAAd,oBAAc;QAAd,6BAAc;;QAAd,sBAAc;QAAd,kBAAc;QAAd,+BAAc;;QAAd,mBAAc;QAAd,sBAAc;QAAd,iCAAc;;QAAd,iBAAc;QAAd,4BAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,kBAAc;QAAd,iBAAc;QAAd,iBAAc;QAAd,gBAAc;;QAAd,sBAAc;QAAd,sBAAc;QAAd,2BAAc;QAAd,wBAAc;QAAd,yBAAc;QAAd,yBAAc;;QAAd,kCAAc;QAAd,+CAAc;QAAd,qDAAc;QAAd,iDAAc;QAAd,mDAAc;IAAA;;AAAd;QAAA,wCAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,eAAc;QAAd,2BAAc;QAAd,kBAAc;QAAd,8BAAc;;QAAd,sBAAc;QAAd,mBAAc;QAAd,+BAAc;;QAAd,mBAAc;QAAd,sBAAc;QAAd,iCAAc;;QAAd,iBAAc;QAAd,4BAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,kBAAc;QAAd,iBAAc;QAAd,iBAAc;;QAAd,sBAAc;QAAd,uBAAc;QAAd,2BAAc;QAAd,wBAAc;QAAd,yBAAc;QAAd,yBAAc;IAAA;;AAAd;QAAA,gCAAc;IAAA;;AAAd;QAAA,wCAAc;QAAd,6BAAc;IAAA;;AAAd,uDAAc;;AAAd;QAAA,mCAAc;QAAd,mBAAc;QAAd,wCAAc;IAAA;;AAAd,mCAAc;;AAAd;;;QAAA,0BAAc;IAAA;;AAAd,qBAAc;;AAAd;QAAA,uBAAc;IAAA;;AAAd,0BAAc;;AAAd;;;;;;QAAA,kBAAc;IAAA;;AAAd;QAAA,iBAAc;IAAA;;AAAd;QAAA,4BAAc;IAAA;;AAAd;QAAA,oBAAc;QAAd,qBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,uBAAc;QAAd,mBAAc;QAAd,gBAAc;QAAd,YAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;IAAA;;AAAd,+BAAc;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAsJhB,8CAA8C;AAM9C,gCAAgC;AAKhC,2BAA2B;AAqB3B,2BAA2B;AAK3B,+BAA+B;AAK/B,0CAA0C;AAK1C,4BAA4B;AApMhC;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA8Mf,0CAA0C;AAC1C;QACI,wBAAwB;QACxB,qBAAqB;IACzB;AAEA;QACI,aAAa;IACjB;AAEA,0CAA0C;AAS1C,mDAAmD;AAMnD,oCAAoC;AAMpC,oCAAoC;AAepC,4CAA4C;AAC5C;QACI,UAAU;QACV,WAAW;IACf;AAEA;QACI,+BAA+B;IACnC;AAEA;QACI,8BAA8B;QAC9B,mBAAmB;IACvB;AAEA;QACI,8BAA8B;IAClC;AAEA,2CAA2C;AAC3C;QACI,UAAU;QACV,WAAW;IACf;AAEA;QACI,qCAAqC;IACzC;AAEA;QACI,qCAAqC;QACrC,mBAAmB;IACvB;AAEA;QACI,oCAAoC;IACxC;AA0CA,6BAA6B;AAC7B;QACI,wCAAwC;IAC5C;AAEA;QACI;YACI,UAAU;YACV,2BAA2B;QAC/B;QACA;YACI,UAAU;YACV,wBAAwB;QAC5B;IACJ;AAEA,qCAAqC;AAKrC;QACI;YACI,4BAA4B;QAChC;QACA;YACI,wBAAwB;QAC5B;IACJ;AAEA,gCAAgC;AAKhC;QACI,sDAAsD;QACtD,wBAAwB;IAC5B;AAEA;QACI;YACI,kCAAkC;QACtC;;QAEA;YACI,oCAAoC;QACxC;;QAEA;YACI,uCAAuC;QAC3C;IACJ;AA9XJ;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,qBAAqB;AACrB;IACI,SAAS;IACT,yFAAyF;IACzF,mCAAmC;IACnC,kCAAkC;IAClC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,iGAAiG;AACrG;;AAEA;;6BAE6B;;AAgF7B;;6BAE6B;;AA6C7B;;6BAE6B;;AAuD7B;;6BAE6B;;AAuF7B;;6BAE6B;;AAiC7B;;6BAE6B;;AAyD7B;;6BAE6B;;AAgB7B;;6BAE6B;AAC7B;;IAEI,8CAA8C;IAC9C;;;;;;;;;;;;;;;QAeI,wBAAwB;QACxB,6BAA6B;QAC7B,qBAAqB;QACrB,+BAA+B;IACnC;;IAEA;;QAEI,uBAAuB;QACvB,4BAA4B;QAC5B,4BAA4B;QAC5B,uBAAuB;QACvB,yBAAyB;QACzB,iCAAiC;QACjC,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,sBAAsB;QACtB,oBAAoB;QACpB,0BAA0B;QAC1B,gCAAgC;QAChC,iBAAiB;QACjB,2BAA2B;QAC3B,uBAAuB;QACvB,6BAA6B;QAC7B,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA,yDAAyD;IACzD;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA,mFAAmF;IACnF;QACI,SAAS;QACT,iBAAiB;IACrB;;IAEA,gDAAgD;IAChD;;;;QAKI,oCAAoC;IACxC;AACJ;AAjfA;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,QAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,sBAifC;EAjfD;AAifC;AAjfD;EAAA,iDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,2BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,iBAifC;EAjfD,iBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,kEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,oEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,mEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,oEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,mEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,mEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,qEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,oEAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,0EAifC;EAjfD,8FAifC;EAjfD;AAifC;AAjfD;EAAA,0CAifC;EAjfD,qDAifC;EAjfD;AAifC;AAjfD;EAAA,2CAifC;EAjfD,sDAifC;EAjfD;AAifC;AAjfD;EAAA,+EAifC;EAjfD,mGAifC;EAjfD;AAifC;AAjfD;EAAA,6EAifC;EAjfD,iGAifC;EAjfD;AAifC;AAjfD;EAAA,0CAifC;EAjfD,uDAifC;EAjfD;AAifC;AAjfD;EAAA,gFAifC;EAjfD,oGAifC;EAjfD;AAifC;AAjfD;EAAA,uCAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,iCAifC;EAjfD;AAifC;AAjfD;EAAA,gCAifC;EAjfD;AAifC;AAjfD;EAAA,mGAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,8BAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,8BAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA,2GAifC;EAjfD,yGAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA,gBAifC;EAjfD,gBAifC;EAjfD;AAifC;AAjfD;EAAA,iBAifC;EAjfD,iBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,iBAifC;EAjfD,cAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD,kBAifC;EAjfD;AAifC;AAjfD;EAAA,iBAifC;EAjfD,iBAifC;EAjfD;AAifC;AAjfD;EAAA,eAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,+EAifC;EAjfD,mGAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,yBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,yBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA,gDAifC;EAjfD;AAifC;AAjfD;EAAA,iDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,0EAifC;EAjfD,8FAifC;EAjfD;AAifC;AAjfD;EAAA,6EAifC;EAjfD,iGAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA,0CAifC;EAjfD,uDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,qBAifC;EAjfD,yBAifC;EAjfD,2BAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,+BAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD,yBAifC;EAjfD,2BAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,+BAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD,yBAifC;EAjfD,2BAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,+BAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,wBAifC;EAjfD,yBAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,wBAifC;EAjfD,yBAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,wBAifC;EAjfD,yBAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD,yBAifC;EAjfD,0BAifC;EAjfD,wBAifC;EAjfD,yBAifC;EAjfD,8BAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,sBAifC;EAjfD;AAifC;AAjfD;EAAA,0BAifC;EAjfD,qBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,mBAifC;EAjfD;AAifC;AAjfD;;EAAA;IAAA;EAifC;AAAA;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,yEAifC;EAjfD,mEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,mEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,kEAifC;EAjfD;AAifC;AAjfD;EAAA,4DAifC;EAjfD,kEAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,uCAifC;EAjfD;AAifC;AAjfD;EAAA,uCAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,4DAifC;EAjfD,qEAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;;EAAA;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,sBAifC;IAjfD;EAifC;;EAjfD;IAAA,sBAifC;IAjfD;EAifC;;EAjfD;IAAA,sBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,sDAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,oDAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,2DAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA,qBAifC;IAjfD;EAifC;;EAjfD;IAAA,oBAifC;IAjfD;EAifC;;EAjfD;IAAA,qBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,iBAifC;IAjfD;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA,eAifC;IAjfD;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,0BAifC;IAjfD;EAifC;;EAjfD;IAAA,qBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;AAAA;AAjfD;;EAAA;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,4DAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,oBAifC;IAjfD;EAifC;;EAjfD;IAAA,iBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,eAifC;IAjfD;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;AAAA;AAjfD;;EAAA;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,8DAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,+DAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,4DAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,+DAifC;IAjfD;EAifC;;EAjfD;IAAA,uBAifC;IAjfD,8DAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,oBAifC;IAjfD;EAifC;;EAjfD;IAAA,oBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA,iBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,iBAifC;IAjfD;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,eAifC;IAjfD;EAifC;;EAjfD;IAAA,mBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA,kBAifC;IAjfD;EAifC;;EAjfD;IAAA,sBAifC;IAjfD;EAifC;AAAA;AAjfD;;EAAA;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;AAAA;AAjfD;;EAAA;IAAA;EAifC;AAAA;AAjfD;;EAAA;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA;EAifC;;EAjfD;IAAA,sBAifC;IAjfD,8BAifC;IAjfD;EAifC;AAAA;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,kDAifC;EAjfD;AAifC;AAjfD;EAAA,iDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,iDAifC;EAjfD;AAifC;AAjfD;EAAA,kDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kDAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,gBAifC;EAjfD,oBAifC;EAjfD,4BAifC;EAjfD;AAifC;AAjfD;EAAA,sBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,WAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA,mBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,qBAifC;EAjfD;AAifC;AAjfD;EAAA,kBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA,oBAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA,WAifC;EAjfD;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC;AAjfD;EAAA;AAifC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Oswald:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Base Body Styles */\nbody {\n    margin: 0;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* Prevent horizontal overflow on mobile */\n    overflow-x: hidden;\n}\n\ncode {\n    font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* ========================\n   CSS Custom Properties\n   ======================== */\n@layer base {\n    :root {\n        /* DMK Theme - Light Mode (Black & Red) */\n        --background: 0 0% 97%;\n        --foreground: 0 0% 8%;\n        --card: 0 0% 100%;\n        --card-foreground: 0 0% 8%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 0 0% 8%;\n\n        /* DMK Black Primary */\n        --primary: 0 0% 8%;\n        --primary-foreground: 0 0% 100%;\n\n        /* DMK Red Accent */\n        --secondary: 0 84% 40%;\n        --secondary-foreground: 0 0% 100%;\n\n        --muted: 0 0% 94%;\n        --muted-foreground: 0 0% 40%;\n        --accent: 0 84% 40%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 0 84% 60%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 0 0% 82%;\n        --input: 0 0% 82%;\n        --ring: 0 84% 40%;\n        --radius: 0.5rem;\n\n        /* Custom DMK colors */\n        --police-navy: 0 0% 8%;\n        --police-navy-dark: 0 0% 5%;\n        --police-gold: 0 84% 40%;\n        --police-badge: 0 84% 35%;\n        --police-silver: 0 0% 71%;\n        \n        /* Safe area for notched devices */\n        --safe-area-inset-top: env(safe-area-inset-top);\n        --safe-area-inset-bottom: env(safe-area-inset-bottom);\n        --safe-area-inset-left: env(safe-area-inset-left);\n        --safe-area-inset-right: env(safe-area-inset-right);\n    }\n\n    .dark {\n        /* DMK Theme - Dark Mode (Black & Red) */\n        --background: 0 0% 5%;\n        --foreground: 0 0% 95%;\n        --card: 0 0% 8%;\n        --card-foreground: 0 0% 95%;\n        --popover: 0 0% 8%;\n        --popover-foreground: 0 0% 95%;\n\n        /* DMK Black Primary */\n        --primary: 0 0% 12%;\n        --primary-foreground: 0 0% 100%;\n\n        /* DMK Red Accent */\n        --secondary: 0 84% 45%;\n        --secondary-foreground: 0 0% 100%;\n\n        --muted: 0 0% 14%;\n        --muted-foreground: 0 0% 65%;\n        --accent: 0 84% 45%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 0 84% 60%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 0 0% 18%;\n        --input: 0 0% 14%;\n        --ring: 0 84% 45%;\n\n        /* Custom DMK colors */\n        --police-navy: 0 0% 12%;\n        --police-navy-dark: 0 0% 8%;\n        --police-gold: 0 84% 45%;\n        --police-badge: 0 84% 38%;\n        --police-silver: 0 0% 65%;\n    }\n}\n\n/* ========================\n   Base Element Styles\n   ======================== */\n@layer base {\n    * {\n        border-color: hsl(var(--border));\n    }\n    \n    body {\n        background-color: hsl(var(--background));\n        color: hsl(var(--foreground));\n    }\n\n    /* Focus visible styles for accessibility - GOV-style */\n    *:focus-visible {\n        outline: 2px solid hsl(var(--ring));\n        outline-offset: 2px;\n        border-radius: calc(var(--radius) - 2px);\n    }\n    \n    /* Better touch targets on mobile */\n    button, \n    [role=\"button\"], \n    a {\n        touch-action: manipulation;\n    }\n    \n    /* Smooth scrolling */\n    html {\n        scroll-behavior: smooth;\n    }\n    \n    /* Better text rendering */\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        text-wrap: balance;\n    }\n    \n    p {\n        text-wrap: pretty;\n    }\n}\n\n/* ========================\n   Component Utilities\n   ======================== */\n@layer components {\n    /* GOV-style cards with professional borders */\n    .gov-card {\n        @apply bg-card border border-border rounded-lg shadow-sm;\n        @apply hover:shadow-md transition-shadow duration-200;\n    }\n    \n    /* Professional header styling */\n    .gov-header {\n        @apply border-b-2 border-secondary pb-4 mb-6;\n    }\n    \n    /* GOV badge/chip styling */\n    .gov-badge {\n        @apply inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold;\n        @apply border transition-colors duration-150;\n    }\n    \n    .gov-badge-high {\n        @apply bg-red-50 text-red-700 border-red-200;\n        @apply dark:bg-red-950 dark:text-red-400 dark:border-red-800;\n    }\n    \n    .gov-badge-medium {\n        @apply bg-amber-50 text-amber-700 border-amber-200;\n        @apply dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800;\n    }\n    \n    .gov-badge-low {\n        @apply bg-emerald-50 text-emerald-700 border-emerald-200;\n        @apply dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800;\n    }\n    \n    /* Mobile-first container */\n    .mobile-container {\n        @apply px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto;\n    }\n    \n    /* Touch-friendly button base */\n    .touch-target {\n        @apply min-h-[44px] min-w-[44px];\n    }\n    \n    /* Responsive grid that stacks on mobile */\n    .responsive-grid {\n        @apply grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4;\n    }\n    \n    /* Mobile-first stat cards */\n    .stat-card-grid {\n        @apply grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4;\n    }\n}\n\n/* ========================\n   Utility Classes\n   ======================== */\n@layer utilities {\n    /* Hide scrollbar but keep functionality */\n    .scrollbar-hide {\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n    }\n    \n    .scrollbar-hide::-webkit-scrollbar {\n        display: none;\n    }\n    \n    /* Safe area padding for notched devices */\n    .safe-area-inset-top {\n        padding-top: var(--safe-area-inset-top);\n    }\n    \n    .safe-area-inset-bottom {\n        padding-bottom: var(--safe-area-inset-bottom);\n    }\n    \n    /* Prevent text selection on interactive elements */\n    .no-select {\n        -webkit-user-select: none;\n        user-select: none;\n    }\n    \n    /* Hardware accelerated animations */\n    .gpu-accelerated {\n        transform: translateZ(0);\n        will-change: transform;\n    }\n    \n    /* Mobile-friendly text truncation */\n    .truncate-2 {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n    }\n    \n    .truncate-3 {\n        display: -webkit-box;\n        -webkit-line-clamp: 3;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n    }\n\n    /* Custom Scrollbar for Sidebar/Dark Areas */\n    .custom-scrollbar::-webkit-scrollbar {\n        width: 6px;\n        height: 8px;\n    }\n\n    .custom-scrollbar::-webkit-scrollbar-track {\n        background: rgba(0, 0, 0, 0.03);\n    }\n\n    .custom-scrollbar::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.2);\n        border-radius: 10px;\n    }\n\n    .custom-scrollbar::-webkit-scrollbar-thumb:hover {\n        background: rgba(0, 0, 0, 0.3);\n    }\n\n    /* Dark variant for navy/dark backgrounds */\n    .custom-scrollbar-dark::-webkit-scrollbar {\n        width: 6px;\n        height: 6px;\n    }\n\n    .custom-scrollbar-dark::-webkit-scrollbar-track {\n        background: rgba(255, 255, 255, 0.05);\n    }\n\n    .custom-scrollbar-dark::-webkit-scrollbar-thumb {\n        background: rgba(255, 255, 255, 0.25);\n        border-radius: 10px;\n    }\n\n    .custom-scrollbar-dark::-webkit-scrollbar-thumb:hover {\n        background: rgba(255, 255, 255, 0.4);\n    }\n}\n\n/* ========================\n   Debug Wrapper (Existing)\n   ======================== */\n@layer base {\n    [data-debug-wrapper=\"true\"] {\n        display: contents !important;\n    }\n\n    [data-debug-wrapper=\"true\"]>* {\n        margin-left: inherit;\n        margin-right: inherit;\n        margin-top: inherit;\n        margin-bottom: inherit;\n        padding-left: inherit;\n        padding-right: inherit;\n        padding-top: inherit;\n        padding-bottom: inherit;\n        column-gap: inherit;\n        row-gap: inherit;\n        gap: inherit;\n        border-left-width: inherit;\n        border-right-width: inherit;\n        border-top-width: inherit;\n        border-bottom-width: inherit;\n        border-left-style: inherit;\n        border-right-style: inherit;\n        border-top-style: inherit;\n        border-bottom-style: inherit;\n        border-left-color: inherit;\n        border-right-color: inherit;\n        border-top-color: inherit;\n        border-bottom-color: inherit;\n    }\n}\n\n/* ========================\n   Animation Utilities\n   ======================== */\n@layer utilities {\n    /* Subtle fade-in animation */\n    .animate-fade-in {\n        animation: fadeIn 0.3s ease-out forwards;\n    }\n    \n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n            transform: translateY(10px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n    \n    /* Slide-in from left (for sidebar) */\n    .animate-slide-in-left {\n        animation: slideInLeft 0.3s ease-out forwards;\n    }\n    \n    @keyframes slideInLeft {\n        from {\n            transform: translateX(-100%);\n        }\n        to {\n            transform: translateX(0);\n        }\n    }\n    \n    /* Pulse for status indicators */\n    .animate-pulse-slow {\n        animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    }\n\n    .animate-progress-indeterminate {\n        animation: progress-indeterminate 1.5s infinite linear;\n        transform-origin: 0% 50%;\n    }\n\n    @keyframes progress-indeterminate {\n        0% {\n            transform: translateX(0) scaleX(0);\n        }\n\n        40% {\n            transform: translateX(0) scaleX(0.4);\n        }\n\n        100% {\n            transform: translateX(100%) scaleX(0.5);\n        }\n    }\n}\n\n/* ========================\n   Responsive Typography\n   ======================== */\n@layer base {\n    /* Mobile-first heading sizes */\n    .heading-responsive {\n        @apply text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight;\n    }\n    \n    .subheading-responsive {\n        @apply text-base sm:text-lg lg:text-xl font-semibold;\n    }\n    \n    .body-responsive {\n        @apply text-sm sm:text-base;\n    }\n}\n\n/* ========================\n   Print Styles (for reports)\n   ======================== */\n@media print {\n\n    /* Aggressively hide all non-report elements */\n    .no-print,\n    nav,\n    aside,\n    header,\n    footer,\n    .sidebar,\n    .main-header,\n    .control-buttons,\n    button:not(.print-only),\n    [data-radix-portal],\n    .fixed.inset-0,\n    .shadow-2xl,\n    .shadow-xl,\n    .bg-black\\/50,\n    .bg-black\\/20 {\n        display: none !important;\n        visibility: hidden !important;\n        opacity: 0 !important;\n        pointer-events: none !important;\n    }\n\n    html,\n    body {\n        height: auto !important;\n        overflow: visible !important;\n        background: white !important;\n        color: black !important;\n        print-color-adjust: exact;\n        -webkit-print-color-adjust: exact;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n\n    .report-document {\n        display: block !important;\n        visibility: visible !important;\n        width: 100% !important;\n        margin: 0 !important;\n        padding: 10mm 0 !important;\n        /* Add vertical safety padding */\n        min-height: 297mm;\n        box-shadow: none !important;\n        border: none !important;\n        position: relative !important;\n        z-index: 9999 !important;\n        background: white !important;\n    }\n\n    /* Secret technique for repeating margins on EVERY page */\n    .report-page-header-spacer {\n        height: 1.5cm;\n    }\n\n    .report-page-footer-spacer {\n        height: 1cm;\n    }\n\n    table.report-print-container {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    thead.report-header-spacer {\n        display: table-header-group;\n    }\n\n    tfoot.report-footer-spacer {\n        display: table-footer-group;\n    }\n\n    /* Professional report layout - setting margin to 0 hides browser headers/footers */\n    @page {\n        margin: 0;\n        size: A4 portrait;\n    }\n\n    /* Force background colors for specific blocks */\n    .bg-slate-50,\n    .bg-white,\n    .bg-blue-600,\n    .bg-\\[\\#071633\\] {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
